const data = [
  {
    "_id": "1112221111",
    "name": "احمد محمد احمد",
    "number": "1000",
    "room": "1",
    "location": "أولى اول",
    "class": "الأول المتوسط",
    "school": "المتوسطة الاولى"
  },
  {
    "_id": "2375730708",
    "name": "احمد حسام علي الدسوقي",
    "number": "111450101",
    "room": "1",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1150083853",
    "name": "بتال بن عبدالناصر بن محمد الدوسري",
    "number": "111450102",
    "room": "1",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1157995034",
    "name": "بدر بن عبدالله بن نوار الحارثيِ",
    "number": "111450103",
    "room": "1",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1153051352",
    "name": "خالد بن عايض بن محمد آل مسعود القحطاني",
    "number": "111450104",
    "room": "1",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1152891402",
    "name": "خالد بن فيصل بن محمد الفويس",
    "number": "111450105",
    "room": "1",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1150861415",
    "name": "خالد بن محمد بن خالد العريعر",
    "number": "111450106",
    "room": "1",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1153187875",
    "name": "خالد بن محمد بن خالد الودعاني الدوسري",
    "number": "111450107",
    "room": "1",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1150807285",
    "name": "راشد بن عبدالهادي بن مبارك العرجي القحطاني",
    "number": "111450108",
    "room": "1",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1145547061",
    "name": "ابراهيم بن سعود بن عبدالله الميمونى المطيري",
    "number": "121600201",
    "room": "1",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1146715030",
    "name": "أحمد بن رائد بن احمد آل سعد",
    "number": "121600202",
    "room": "1",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1156731091",
    "name": "بدر بن بين بن محمد الصندلي السبيعي",
    "number": "121600203",
    "room": "1",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1148427386",
    "name": "بندر بن محمد بن سعد الدوسري",
    "number": "121600204",
    "room": "1",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1144977707",
    "name": "تركي بن نواف بن معتاد العتيبي",
    "number": "121600205",
    "room": "1",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1149109710",
    "name": "جبر بن بدر بن جزاع التريباني الشمري",
    "number": "121600206",
    "room": "1",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1148590944",
    "name": "خالد بن وليد بن عبدالله الربيعان",
    "number": "121600207",
    "room": "1",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1148092263",
    "name": "خلف بن محمد بن خلف الشملاني العنزي",
    "number": "121600208",
    "room": "1",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1144599915",
    "name": "ابراهيم بن خليل بن ابراهيم الخريجي",
    "number": "131600301",
    "room": "1",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1144511977",
    "name": "ابراهيم حمد ابراهيم الحميدي",
    "number": "131600302",
    "room": "1",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1144869847",
    "name": "أحمد بن عبدالله بن احمد المذن",
    "number": "131600303",
    "room": "1",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1142460672",
    "name": "أمير بن محمد بن فهد اليحيى",
    "number": "131600304",
    "room": "1",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1143513214",
    "name": "بدر بن طلال بن محمد آل زايد الهاجري",
    "number": "131600305",
    "room": "1",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1144850003",
    "name": "جاسر بن سعيد بن سعد آل بوسكيته القحطاني",
    "number": "131600306",
    "room": "1",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1141993533",
    "name": "جلال بن مرجع بن علي ال عامر اليامي",
    "number": "131600307",
    "room": "1",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1153475080",
    "name": "ريان بن حمد بن خلف سعد الهيف",
    "number": "111450109",
    "room": "2",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1145329593",
    "name": "زياد بن حسن بن رشود الدوسري",
    "number": "111450110",
    "room": "2",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1155981366",
    "name": "سعود بن عبد الله بن صالح الدرويش",
    "number": "111450111",
    "room": "2",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1153891195",
    "name": "سعيد بن سالم بن سعيد ال زاهر القحطاني",
    "number": "111450112",
    "room": "2",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1148923434",
    "name": "عامر بن نايف بن حبيب الخالدي",
    "number": "111450113",
    "room": "2",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1151292800",
    "name": "عبدالاله بن علي بن محمد بدري",
    "number": "111450114",
    "room": "2",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1150786158",
    "name": "عبدالله بن محمد بن مسعد القلادي الرشيدي",
    "number": "111450115",
    "room": "2",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1151291307",
    "name": "عبدالله نواف معزى الشريهى",
    "number": "111450116",
    "room": "2",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1155288705",
    "name": "عبدالهادي بن عبدالله بن عبدالهادي البرزان",
    "number": "111450117",
    "room": "2",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1159151545",
    "name": "راكان بن خالد بن ابراهيم جمعان",
    "number": "121600209",
    "room": "2",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1149764126",
    "name": "زياد أحمد بن منير آل راكان",
    "number": "121600210",
    "room": "2",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1147473738",
    "name": "زياد بن مناحي بن مفلح القحطاني",
    "number": "121600211",
    "room": "2",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1145137616",
    "name": "سامي بن حمد بن شامي شوك",
    "number": "121600212",
    "room": "2",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1154942062",
    "name": "سعد بن ناصر بن سعيد آل فهد السبيعي",
    "number": "121600213",
    "room": "2",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1148330499",
    "name": "سعود بن فهد بن عبد الرحمن الرمالي الشمري",
    "number": "121600214",
    "room": "2",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1146144330",
    "name": "عادل بن ياسر بن حسين آل مساعد اليامي",
    "number": "121600215",
    "room": "2",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1143862876",
    "name": "عبدالعزيز بن سليمان بن حوران الفريجي الرويلي",
    "number": "121600216",
    "room": "2",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1138495443",
    "name": "خالد بن محمد بن مطلق السبيعي",
    "number": "131600308",
    "room": "2",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1123917815",
    "name": "سالم بن عبدالله بن سالم الملاح",
    "number": "131600309",
    "room": "2",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1153716509",
    "name": "سعد بن خالد بن سعد العتيبي",
    "number": "131600310",
    "room": "2",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1141881167",
    "name": "سعد بن عبدالله بن سعد العضيلة المطيري",
    "number": "131600311",
    "room": "2",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1145117352",
    "name": "سعود بن سالم بن عبدالخالق آل قسقس الغامدي",
    "number": "131600312",
    "room": "2",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1142272200",
    "name": "سلطان بن فيصل بن معتاد النفيعي العتيبي",
    "number": "131600313",
    "room": "2",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1142166121",
    "name": "سلطان بن ناصر بن محمد آل زايد الهاجري",
    "number": "131600314",
    "room": "2",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1145504542",
    "name": "عبدالعزيز بن محمد بن عبدالله محمد الضعيان",
    "number": "121600217",
    "room": "3",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1146868532",
    "name": "عبدالعزيزبن محمد بن خميس الهاجري",
    "number": "121600218",
    "room": "3",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1147789687",
    "name": "عبدالكريم بن محمد ابن عبدالله ال قيشان القحطاني",
    "number": "121600219",
    "room": "3",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1144842794",
    "name": "عبدالله بن بندر بن عبدالله آل سالم اليامي",
    "number": "121600220",
    "room": "3",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1157392232",
    "name": "عبدالله بن داهم بن بتال آل سعد القحطاني",
    "number": "121600221",
    "room": "3",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1146988322",
    "name": "عبدالله بن مبارك بن محمد القحطانى",
    "number": "121600222",
    "room": "3",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1148345331",
    "name": "عبدالله بن ناصر بن هزاع السبيعي",
    "number": "121600223",
    "room": "3",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1145282859",
    "name": "عمر بن سعد بن حمد الميبر الدوسري",
    "number": "121600224",
    "room": "3",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1143777520",
    "name": "صالح بن عبدالله بن صالح عبدالله الدرويش",
    "number": "131600315",
    "room": "3",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1145572341",
    "name": "صالح بن فيصل بن محمد الفويس",
    "number": "131600316",
    "room": "3",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "2543516948",
    "name": "صهيب محمد عبدالكريم عليوه",
    "number": "131600317",
    "room": "3",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1142051208",
    "name": "عبد الله بن على بن راشد النعيمى",
    "number": "131600318",
    "room": "3",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1141981389",
    "name": "عبدالرحمن بن طارق بن عبدالله العيسى",
    "number": "131600319",
    "room": "3",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1141525871",
    "name": "عبدالرحمن بن علي بن محمد بدري",
    "number": "131600320",
    "room": "3",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1144683644",
    "name": "عبدالله بن فهد بن فيحان الدعجاني العتيبي",
    "number": "131600321",
    "room": "3",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1153426687",
    "name": "عمر بن ناصر بن عمر آل مسعود القحطاني",
    "number": "111450118",
    "room": "4",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1154163792",
    "name": "فهد بن يوسف بن سليمان المبيض",
    "number": "111450119",
    "room": "4",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1152298723",
    "name": "فيصل بن تركي بن حمود المهشوري",
    "number": "111450120",
    "room": "4",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1149942987",
    "name": "فيصل بن عيد بن محمد آل مسعود القحطاني",
    "number": "111450121",
    "room": "4",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1151630835",
    "name": "محمد بن بندر بن عبدالله آل سالم اليامي",
    "number": "111450122",
    "room": "4",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1150289369",
    "name": "محمد بن سلطان بن محمد ابن شرقة",
    "number": "111450123",
    "room": "4",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1150145686",
    "name": "محمد بن عماد بن محمد الخليف",
    "number": "111450124",
    "room": "4",
    "location": "المسرح ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1148101692",
    "name": "محمد بن فيصل بن مسفر النعيمي",
    "number": "111450125",
    "room": "4",
    "location": "المسرح ",
    "class": "الثاني الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1147041543",
    "name": "عمر بن عبدالعزيز بن زيد الدويرج",
    "number": "121600225",
    "room": "4",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1144357637",
    "name": "عبدالله بن نافع بن عبدالله المسعود العارضي",
    "number": "131600322",
    "room": "4",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1145549067",
    "name": "عبدالله عيد بن عبدالله العامري",
    "number": "131600323",
    "room": "4",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1144308978",
    "name": "علي بن خالد بن علي المزيد",
    "number": "131600324",
    "room": "4",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1142313277",
    "name": "فراس مسفر سعيد الغامدي",
    "number": "131600325",
    "room": "4",
    "location": "المسرح ",
    "class": "الثالث الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1146416324",
    "name": "فارس بن عايض بن مبارك آل قير القحطاني",
    "number": "121600226",
    "room": "4",
    "location": "المسرح ",
    "class": "الثاني الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1148425406",
    "name": "فالح بن راشد بن جابر ال مرسان الهاجرى",
    "number": "121600227",
    "room": "4",
    "location": "المسرح ",
    "class": "الثاني الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1148949504",
    "name": "فهد بن محسن بن عمر العصيمي العتيبي",
    "number": "121600228",
    "room": "4",
    "location": "المسرح ",
    "class": "الثاني الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1145414965",
    "name": "فيصل بن محمد بن فيصل الشلوي",
    "number": "121600229",
    "room": "4",
    "location": "المسرح ",
    "class": "الثاني الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1149368266",
    "name": "محمد بن بشير بن سعد المصلوخي العنزي",
    "number": "121600230",
    "room": "4",
    "location": "المسرح ",
    "class": "الثاني الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1133975852",
    "name": "محمد بن فائز بن محمد الشهري",
    "number": "121600231",
    "room": "4",
    "location": "المسرح ",
    "class": "الثاني الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1146693856",
    "name": "محمد بن فارس بن محمد آل عباس",
    "number": "121600232",
    "room": "4",
    "location": "المسرح ",
    "class": "الثاني الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1142967155",
    "name": "محمد بن ابراهيم بن علي هزازي",
    "number": "131600326",
    "room": "4",
    "location": "المسرح ",
    "class": "الثالث الثانوي  ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1142681434",
    "name": "محمد بن زايد بن محمد البكري الشهري",
    "number": "131600327",
    "room": "4",
    "location": "المسرح ",
    "class": "الثالث الثانوي  ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1145252837",
    "name": "محمد بن سعود بن عبدالله القعود",
    "number": "131600328",
    "room": "4",
    "location": "المسرح ",
    "class": "الثالث الثانوي  ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1168746608",
    "name": "محمد بن ناصر بن سعيد آل فهد السبيعي",
    "number": "111450126",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1153284680",
    "name": "محمد بن يعقوب بن فهيد الحمياني",
    "number": "111450127",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1143946414",
    "name": "مشعل بن محمد بن محسن الرويلي",
    "number": "111450128",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1150008801",
    "name": "مهند بن الوليد بن عبدالعزيز عبدالله القضيب",
    "number": "111450129",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1149254458",
    "name": "ناصر بن خالد بن ناصر الدوسري",
    "number": "111450130",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1152524003",
    "name": "هادي بن سعيد بن هادي الهاجري",
    "number": "111450131",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1151570494",
    "name": "ياسر بن خالد بن عطاالله الوهبي الحربي",
    "number": "111450132",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1148737149",
    "name": "يحيى بن عبدالله بن يحى الخزمري الزهراني",
    "number": "111450133",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1151202700",
    "name": "يزن بن سفران بن عبدالله الشمراني",
    "number": "111450134",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1145388250",
    "name": "يوسف بن كمال بن عبدالوهاب الجوهرجي",
    "number": "111450135",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الأول الثانوي",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1137106983",
    "name": "محمد بن فهيد بن محسن الهاجري",
    "number": "121600233",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الثاني الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1147142028",
    "name": "مشاري بن برجس بن سعد العزيزي المطيري",
    "number": "121600234",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الثاني الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1147373151",
    "name": "نايف بن مناحي بن عالي المقاطي العتيبي",
    "number": "121600236",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الثاني الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1147345365",
    "name": "وسام بن سليمان بن خلف آل باحص الغامدي",
    "number": "121600237",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الثاني الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1148491622",
    "name": "ياسر بن سعد بن مبارك آل قنينه القحطاني",
    "number": "121600238",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الثاني الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "2305739456",
    "name": "يامن عصام محمود ابولطيفه",
    "number": "121600239",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الثاني الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1142579414",
    "name": "محمد بن عمير بن عبدالرحمن المعيض الزهراني",
    "number": "131600329",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الثالث الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1142359189",
    "name": "محمد بن فهد بن معتاد النفيعي العتيبي",
    "number": "131600330",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الثالث الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1143866711",
    "name": "مروان بن خليفه بن علي الدنيني",
    "number": "131600331",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الثالث الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1144028261",
    "name": "مطلق بن منيف بن عبدالله الهاجري",
    "number": "131600332",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الثالث الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1142843067",
    "name": "نايف بن جمال بن سعيد العنزي",
    "number": "131600333",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الثالث الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1145141204",
    "name": "نايف بن علي بن محمد العمرن الشهري",
    "number": "131600334",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الثالث الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1142100195",
    "name": "ياسر بن ابراهيم بن مساعد القلوي الزهراني",
    "number": "131600335",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الثالث الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1140967595",
    "name": "يزن بن سعيد بن علي ال نايش القرني",
    "number": "131600336",
    "room": "5",
    "location": "معمل القدرات ",
    "class": "الثالث الثانوي ",
    "school": "مدرسة اليرموك الثانوية الاهلية "
  },
  {
    "_id": "1166446946",
    "name": "اسامه سلطان جديع العنزي",
    "number": "7250051",
    "room": "1",
    "location": "المصلى ",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1162625956",
    "name": "بسام بن سليمان بن خلف آل باحص الغامدي",
    "number": "7250052",
    "room": "1",
    "location": "المصلى ",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1162205031",
    "name": "حاتم بن علي بن محمد ال هديب القحطاني",
    "number": "7250053",
    "room": "1",
    "location": "المصلى ",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1166533347",
    "name": "حسام بن فائز بن محمد الشهري",
    "number": "7250054",
    "room": "1",
    "location": "المصلى ",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1163069055",
    "name": "خالد بن زيد بن فارس الدربي المليحي",
    "number": "7250055",
    "room": "1",
    "location": "المصلى ",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1163005679",
    "name": "خالد بن سعد بن فرج الوداعين الدوسري",
    "number": "7250056",
    "room": "1",
    "location": "المصلى ",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1163094863",
    "name": "خالد بن علي بن محمد الشهري",
    "number": "7250057",
    "room": "1",
    "location": "المصلى ",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1158391258",
    "name": "ريان بن خليل بن ابراهيم الخريجي",
    "number": "8250081",
    "room": "1",
    "location": "المصلى ",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1159797651",
    "name": "سالم بن فارس بن حسن الفارس زهراني",
    "number": "8250082",
    "room": "1",
    "location": "المصلى ",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1161872898",
    "name": "سليمان بن فواز بن عبدالرحمن المزيد",
    "number": "8250083",
    "room": "1",
    "location": "المصلى ",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1158299576",
    "name": "عبدالله بن عبدالحميد بن هادي آل مساعد اليامي",
    "number": "8250084",
    "room": "1",
    "location": "المصلى ",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1159698339",
    "name": "عمر بن عبدالمحسن بن مرزوق العصيمي العتيبي",
    "number": "8250085",
    "room": "1",
    "location": "المصلى ",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1159984135",
    "name": "فهد بن نواف بن معتاد النفيعى العتيبي",
    "number": "8250086",
    "room": "1",
    "location": "المصلى ",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1159236007",
    "name": "ماجد بن خالد بن علي المزيد",
    "number": "8250087",
    "room": "1",
    "location": "المصلى ",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1162766016",
    "name": "محمد بن عبدالله بن محمد العرافه المطيري",
    "number": "8250088",
    "room": "1",
    "location": "المصلى ",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1156799171",
    "name": "بندر بن فيحان بن عبدالله الفغم",
    "number": "9250101",
    "room": "1",
    "location": "المصلى ",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1156385559",
    "name": "حسين بن علي بن حسين الوجيه اليامي",
    "number": "9250102",
    "room": "1",
    "location": "المصلى ",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1156533851",
    "name": "حمد بن شليل بن حمد آل شيبان",
    "number": "9250103",
    "room": "1",
    "location": "المصلى ",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1155028036",
    "name": "خالد بن محمد بن حسين آل شيبان",
    "number": "9250104",
    "room": "1",
    "location": "المصلى ",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1154110116",
    "name": "ريان بن عمر بن موسى المضحوي الزهراني",
    "number": "9250105",
    "room": "1",
    "location": "المصلى ",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1157605005",
    "name": "سعود بن محمد بن خميس الهاجري",
    "number": "9250106",
    "room": "1",
    "location": "المصلى ",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "2375731631",
    "name": "ريان حسام علي الدسوقي",
    "number": "7250058",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1157821354",
    "name": "سعد بن محسن بن سعد العمار الدوسري",
    "number": "7250059",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1163430083",
    "name": "طارق محمد بن حريش الزهراني",
    "number": "7250060",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1164043232",
    "name": "عبدالله بن عبدالمحسن بن شبل الكعيط",
    "number": "7250061",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1160229975",
    "name": "عبدالله بن محمد بن عبدالله النواجي الاكلبي",
    "number": "7250062",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1166247146",
    "name": "عبدالله بن منصور بن سلطان الهتلان العجمي",
    "number": "7250063",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1154252496",
    "name": "محمد بن نمر بن حسن الغريري الدوسري",
    "number": "8250089",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1152283451",
    "name": "مشعل بن بشير بن جميعان الغيثي الشمري",
    "number": "8250090",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1161320724",
    "name": "مشعل بن بندر بن محمد الريس",
    "number": "8250091",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1159831989",
    "name": "معتاد بن فيصل بن معتاد النفيعي العتيبي",
    "number": "8250092",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1159830718",
    "name": "الوليد بن سعد بن حامد آل عبدان الغامدي",
    "number": "8250095",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1154965790",
    "name": "عبد المحسن بن حمد بن عبد المحسن القحطاني",
    "number": "9250107",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1155712613",
    "name": "عبدالرحمن بن بندر بن عبدالرحمن آل حيدان القحطاني",
    "number": "9250108",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1154064032",
    "name": "عبدالعزيز بن تركي بن عبدالعزيز الخليفة",
    "number": "9250109",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1149030817",
    "name": "معاذ بن عبدالله بن محمد البقمي",
    "number": "9250110",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "2375731342",
    "name": "انس حسام علي الدسوقي",
    "number": "9250111",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1155217449",
    "name": "خالد بن عبدالمحسن بن مرزوق العصيمي العتيبي",
    "number": "9250112",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1157698158",
    "name": "سعود بن فهد بن محمد الصبيح الخالدي",
    "number": "9250113",
    "room": "2",
    "location": "الاول متوسط ",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1164850883",
    "name": "غسان بن عبدالله بن عبدالرحمن السكران",
    "number": "7250064",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1164880955",
    "name": "فيصل بن بندر بن عبدالرحمن آل حيدان القحطاني",
    "number": "7250065",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1164652586",
    "name": "محمد بن احمد بن محمد العصابين العمراني",
    "number": "7250066",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1164185421",
    "name": "محمد بن سعد بن مبارك آل دليم السبيعي",
    "number": "7250067",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1167137502",
    "name": "محمد بن سلامه بن سالم الاشجعي العنزي",
    "number": "7250068",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الاول متوسط ",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1163074840",
    "name": "بسام سعيد عبدالله الدوسري",
    "number": "8250096",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1163406323",
    "name": "تركي بن مبارك بن محمد الودعاني الدوسري",
    "number": "8250097",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1159559119",
    "name": "خالد بن عبدالرحمن بن عبدالله آل سمله العمري",
    "number": "8250098",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1163841693",
    "name": "سعيد بن فهد بن سعيد كليب الدوسري",
    "number": "8250099",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1159866647",
    "name": "عبدالله بن عواد بن فياض العجمي",
    "number": "8250100",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1161471170",
    "name": "عمر بن محمد بن خلف الشملاني العنزي",
    "number": "8250101",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1157530625",
    "name": "فايز بن علي بن فايز آل ظافر الشهري",
    "number": "8250102",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1155422569",
    "name": "عبدالرحمن بن فيصل بن قاسم اليحيى",
    "number": "9250114",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1156268482",
    "name": "عبدالعزيز منيف بن عبدالله الهاجري",
    "number": "9250115",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1157057579",
    "name": "عبدالله بن عماد بن محمد الخليف",
    "number": "9250116",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1155421926",
    "name": "علي بن عبدالله بن علي ال حابس اليامي",
    "number": "9250117",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1155840695",
    "name": "غيث بن خالد بن عبدالله السبيعي",
    "number": "9250118",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1157025444",
    "name": "فيصل بن سعود بن حمد المسردي القحطاني",
    "number": "9250119",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1156772103",
    "name": "مبارك بن علي بن محمد الغباري",
    "number": "9250120",
    "room": "3",
    "location": "صف 3- ب",
    "class": "الثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1165133354",
    "name": "محمد بن عبدالعزيز بن محمد ال قعبوب الرشيدي",
    "number": "7250069",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "اول متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1169014592",
    "name": "محمد بن عبدالله بن مبارك المسردي القحطاني",
    "number": "7250070",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "اول متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1161616352",
    "name": "ناصر علي بن صالح اليامي",
    "number": "7250071",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "اول متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1163244955",
    "name": "ياسر بن عبدالرحمن بن سعد آل قصلي العمري",
    "number": "7250072",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "اول متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1165798263",
    "name": "يوسف بن سالم بن عبد الخالق الغامدي",
    "number": "7250073",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "اول متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1160977920",
    "name": "فهد بن سالم بن عبدالخالق الغامدي",
    "number": "8250103",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "ثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1165915339",
    "name": "محمد بن ذيب بن فهد آل وثيله الدوسري",
    "number": "8250104",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "ثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1158103505",
    "name": "محمد بن عبد الله بن محمد السويدي السبيعي",
    "number": "8250105",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "ثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1161582497",
    "name": "محمد سعد موفى الولماني",
    "number": "8250106",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "ثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "3027987869",
    "name": "مهند محمد رائد أبو خيارة",
    "number": "8250107",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "ثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1153587413",
    "name": "محمد بن حمد بن محمد ال منجم اليامي",
    "number": "9250121",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "ثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1156472241",
    "name": "مشعل بن فهد بن صالح الجديعي",
    "number": "9250122",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "ثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1156699561",
    "name": "موفى سعد موفى الولماني",
    "number": "9250123",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "ثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1159037355",
    "name": "نايف محمد غازي العتيبي",
    "number": "9250124",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "ثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1154546442",
    "name": "نواف بن نبيل بن حمد المسعد",
    "number": "9250125",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "ثالث متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1159877131",
    "name": "نايف بن عبدالرحيم بن دليل المخلفي",
    "number": "8250108",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "ثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "2361668946",
    "name": "نبيل احمد نبيل عياد",
    "number": "8250109",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "ثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1160439251",
    "name": "نواف بن سعيد بن محمد الغامدي",
    "number": "8250110",
    "room": "4",
    "location": "صف 2/ أ",
    "class": "ثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1161738156",
    "name": "نبيل بن حمد بن نبيل المسعد",
    "number": "8250093",
    "room": "2",
    "location": "اول متوسط ",
    "class": "ثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية "
  },
  {
    "_id": "1158429363",
    "name": "يوسف بن احمد بن عبدالقادر الوهيب",
    "number": "8250094",
    "room": "2",
    "location": "اول متوسط ",
    "class": "ثاني متوسط",
    "school": "مدرسة اليرموك المتوسطة الاهلية"
  },
  /* kods */
  {
    "_id": "1169046461",
    "name": "بدر محسن شافي الدوسري",
    "number": "01300761",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1171904749",
    "name": "برجس شجاع حسين المصارير",
    "number": "01300762",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "06327588",
    "name": "تركي ابراهيم محمد احمد الحاج",
    "number": "01300763",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1163936477",
    "name": "خالد طنف قطان الدوسري",
    "number": "01300767",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0201067949",
    "name": "خالد مصعب خالد عوض الكريم",
    "number": "01300768",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1171704909",
    "name": "سعد مبارك سعد الدوسري",
    "number": "01300771",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1171394958",
    "name": "سعد محسن عايض الدوسري",
    "number": "01300772",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1172259499",
    "name": "سعد محمد سعد الدوسري",
    "number": "01300773",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1171113069",
    "name": "سعود نايف مجول الدوسري",
    "number": "01300774",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1170039661",
    "name": "شجاع بداح شجاع الدوسري",
    "number": "01300775",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "2381053012",
    "name": "طلال محمد عادل الشاعر",
    "number": "01300777",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1186104178",
    "name": "عبدالله مرزوق عبدالله الدوسري",
    "number": "01300781",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1173736479",
    "name": "فراج عبدالله فهد الدوسري",
    "number": "01300785",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1169443353",
    "name": "فهد عبدالله خفران الدوسري",
    "number": "01300786",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1170711053",
    "name": "فهد مسعود سعد الدوسري",
    "number": "01300787",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1168752630",
    "name": "فهد مطلق فهد الدوسري",
    "number": "01300788",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1168739017",
    "name": "محماس محمد عايض الدوسري",
    "number": "01300790",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "05877936",
    "name": "محمد ابراهيم محمد  الحاج",
    "number": "01300791",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1188812299",
    "name": "محمد بتال بن مطلق الدوسري",
    "number": "01300792",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1171613134",
    "name": "محمد خالد بن مجول الدوسري",
    "number": "01300793",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1170810335",
    "name": "محمد عبدالعزيز  مدباج الدوسري",
    "number": "01300796",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0201073849",
    "name": "محمد عبدالفتاح عبدالله اسماعيل",
    "number": "01300797",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1169273529",
    "name": "مطلق فراج محمد الدوسري",
    "number": "01300802",
    "room": "61",
    "location": "سادس 1",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0160261219",
    "name": "تركي عبدالمعطي عبده قاسم",
    "number": "01300764",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1174222347",
    "name": "ثامر فرج بن سعد الدوسري",
    "number": "01300765",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "4673004554",
    "name": "حمد علي عبدالله صالح",
    "number": "01300766",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1169081005",
    "name": "سالم فايز سالم الدوسري",
    "number": "01300769",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1171832643",
    "name": "سعد فهد بن عبدالله القباني",
    "number": "01300770",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1195169006",
    "name": "طالب محمد بن حسن شحبل",
    "number": "01300776",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1162434318",
    "name": "عبدالرحمن شبيب مبارك الدوسري",
    "number": "01300778",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1168460846",
    "name": "عبدالرحمن محمد هندي الدوسري",
    "number": "01300779",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1153225378",
    "name": "عبدالله شبيب مبارك الدوسري",
    "number": "01300780",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "14420213072",
    "name": "عمر عبدالله محمد جغمان",
    "number": "01300782",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1164546630",
    "name": "غريب فلاح غريب الدوسري",
    "number": "01300783",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1170768764",
    "name": "فالح فهد فالح الدوسري",
    "number": "01300784",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1166245892",
    "name": "مترك فهد مترك العرجاني",
    "number": "01300789",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1169820436",
    "name": "محمد سالم محمد الدوسري",
    "number": "01300794",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1191108370",
    "name": "محمد ضيف الله شائع المطيري",
    "number": "01300795",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1169310594",
    "name": "محمد فالح عبدالرحمن الدوسري",
    "number": "01300798",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1167416971",
    "name": "محمد فراج بن سهل الدوسري",
    "number": "01300799",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1170761124",
    "name": "مرزوق محمد عبدالله الدوسري",
    "number": "01300800",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1169945951",
    "name": "مشاري بندر خالد المساعره الدوسري",
    "number": "01300801",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1168878625",
    "name": "نايف فلاح غريب الدوسري",
    "number": "01300803",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1162924474",
    "name": "نشمي سالم ظافر الدوسري",
    "number": "01300804",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1164963470",
    "name": "هادي محمد سعد الدوسري",
    "number": "01300805",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0190808142",
    "name": "يزن عمار علي صغير",
    "number": "01300806",
    "room": "62",
    "location": "سادس 2",
    "class": "السادس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0160234995",
    "name": "أمين فهمي هيثم أحمد",
    "number": "01300753",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1168793220",
    "name": "حاتم محمد بن سهيل الدوسري",
    "number": "01300756",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1173559996",
    "name": "خالد مفلح بن محمد الدوسري",
    "number": "01300757",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1176611380",
    "name": "دغش عبدالله دغش الدوسري",
    "number": "01300759",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1181992759",
    "name": "راكان رسل محمد الدوسري",
    "number": "01300760",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1177005467",
    "name": "سالم محمد سالم الدوسري",
    "number": "01300762",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1186553002",
    "name": "سعود شبيب سلطان الدوسري",
    "number": "01300766",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1181992817",
    "name": "سلمان رسل محمد الدوسري",
    "number": "01300768",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1173433457",
    "name": "سلمان فالح بن محمد الدوسري",
    "number": "01300769",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1195100365",
    "name": "سلمان محمد ناصر الدوسري",
    "number": "01300770",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0191024587",
    "name": "طاهر سامر طاهر رزوق",
    "number": "01300773",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1173592708",
    "name": "عبدالرحمن راجس مبارك المصارير",
    "number": "01300775",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1171900101",
    "name": "عبدالرحمن ظافر حسن الشهري",
    "number": "01300776",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1173798610",
    "name": "عبدالرحمن محمد سعد الدوسري",
    "number": "01300777",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1172103168",
    "name": "عبدالرحمن معيكل محمد الدوسري",
    "number": "01300778",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1202083810",
    "name": "فهد سلمان سعد الدوسري",
    "number": "01300782",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1168867578",
    "name": "فيصل متعب بن سالم الدوسري",
    "number": "01300785",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1172403071",
    "name": "ماجد محمد مترك الدوسري",
    "number": "01300786",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1169410345",
    "name": "مبارك راجس مبارك المصارير",
    "number": "01300787",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1181223270",
    "name": "مبارك محمد مبارك الدوسري",
    "number": "01300788",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1176771309",
    "name": "مبارك محمد منصور الدوسري",
    "number": "01300789",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1178720460",
    "name": "محمد فالح محمد العرجاني",
    "number": "01300793",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1175101029",
    "name": "محمد فالح مسعود الدوسري",
    "number": "01300794",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1176390902",
    "name": "ناصر سلمان ناصر الدوسري",
    "number": "01300802",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1180496612",
    "name": "نايف حبنان محمد الدوسري",
    "number": "01300797",
    "room": "52",
    "location": "خامس 2",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "2390105241",
    "name": "أحمد محمد صالح جياش",
    "number": "01300752",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0160745545",
    "name": "الياس حسين علي الغامدي",
    "number": "01300751",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1174447860",
    "name": "أنس جلال سالم الضمجي",
    "number": "01300754",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1182568723",
    "name": "بتال بخيت بن مفلح الدوسري",
    "number": "01300755",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0150514721",
    "name": "خليل عبدالله سعيد كريزم",
    "number": "01300758",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1172834390",
    "name": "سالم فراج سالم الدوسري",
    "number": "01300761",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1172745661",
    "name": "سطام محمد بن حشر الدوسري",
    "number": "01300763",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1169413307",
    "name": "سطام معجب برجس الدوسري",
    "number": "01300764",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1176360285",
    "name": "سعد بدر سعد العتيبي",
    "number": "01300765",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1176558318",
    "name": "سعود علي سعود الدوسري",
    "number": "01300767",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "2454087053",
    "name": "سلمان مرضي حميدي خليف",
    "number": "01300771",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1175646882",
    "name": "ضيدان فيصل ضيدان العجمي",
    "number": "01300772",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0120511071",
    "name": "عاطف سالم عاطف ابو طعيمة",
    "number": "01300774",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0190792047",
    "name": "عبدالعزيز جاسم  عريعر",
    "number": "01590025",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1173600493",
    "name": "عبيد بدر عبيد المصارير",
    "number": "01300779",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0160244302",
    "name": "عزام عادل غالب احمد",
    "number": "01300780",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0201073653",
    "name": "علي ايهاب وهبه مكي",
    "number": "01300781",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1170495871",
    "name": "فهد مرداس بن مبارك العجمي",
    "number": "01300783",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1175007465",
    "name": "فيصل ظافر مفلح الدوسري",
    "number": "01300784",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1176242475",
    "name": "مترك محمد عبيد الدوسري",
    "number": "01300790",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0191053603",
    "name": "محمد جاسم محمد الصالح",
    "number": "01300791",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1175993763",
    "name": "محمد ظافر محمد الدوسري",
    "number": "01300792",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1173889849",
    "name": "محمد فهد سجوان الدوسري",
    "number": "01300795",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1169534490",
    "name": "مسلي ضيدان بن سعد الدوسري",
    "number": "01300796",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0201072235",
    "name": "مكي بشير مكي بشير",
    "number": "01300797",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1171960394",
    "name": "منصور عبدالله بن فالح العرجاني",
    "number": "01300798",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1174377992",
    "name": "ناجي ساير ناصر الدوسري",
    "number": "01300799",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1170856874",
    "name": "نادر محمد هايف الدوسري",
    "number": "01300800",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1163774803",
    "name": "ناصر حمد ناصر الشهري",
    "number": "01300801",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1168068425",
    "name": "هذال صلال بن حارب الدوسري",
    "number": "01300804",
    "room": "51",
    "location": "خامس 1",
    "class": "الخامس الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1179831647",
    "name": "الهاجري أحمد الهاجري العرجاني",
    "number": "01300742",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1176501763",
    "name": "بدر فهد شبنان الدوسري",
    "number": "01300744",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1176108403",
    "name": "تميم فواز تركي الدوسري",
    "number": "01300745",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1177509047",
    "name": "راكان هادي بن عضيب العنزي",
    "number": "01300747",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0191061169",
    "name": "سلطان جميل حمده علي",
    "number": "01300750",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1179718984",
    "name": "عادل محمد عادل الشاعر",
    "number": "01300756",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "2404001378",
    "name": "عائض هويمل عائض الدوسري",
    "number": "01300755",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0150754737",
    "name": "عبد العظيم حسين  تينه",
    "number": "01300757",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1177392931",
    "name": "عبدالرحمن محسن ظافر الدوسري",
    "number": "01300758",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1178861165",
    "name": "عبدالرحمن مرسل عبدالرحمن العرجاني",
    "number": "01300759",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0191053607",
    "name": "عبدالصميد علي عماش الزير",
    "number": "01300760",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0191061041",
    "name": "عبدالله جميل حمده علي",
    "number": "01300761",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1176636759",
    "name": "عبدالله حمد جويعد المصارير",
    "number": "01300762",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1180903880",
    "name": "عبدالله يزيد بتال الدوسري",
    "number": "01300764",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1177629050",
    "name": "عبدالمحسن حمد بن مسفر العجمي",
    "number": "01300765",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1176344602",
    "name": "عساف حمد محمد العرجاني",
    "number": "01300766",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1178214860",
    "name": "عقاب محسن عايض الدوسري",
    "number": "01300767",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1180499657",
    "name": "علي معيض فالح العرجاني",
    "number": "01300769",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1181452812",
    "name": "فالح بخيت فالح العجمي",
    "number": "01300771",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0150754732",
    "name": "فايز عبد المقيم  تينه",
    "number": "01300772",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1178047500",
    "name": "فهد محمد فهد المصارير",
    "number": "01300775",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1178496392",
    "name": "فهد مسلي فهد الدوسري",
    "number": "01300776",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1177931381",
    "name": "فيصل سالم محمد المصارير",
    "number": "01300777",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "2558531832",
    "name": "محمد اشراق محمد ابو طعيمة",
    "number": "01300781",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0150516153",
    "name": "محمد سعيد عز حرب",
    "number": "01300784",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0160244303",
    "name": "محمد عادل غالب احمد",
    "number": "01300785",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1177027073",
    "name": "نايف جازع سعد الدوسري",
    "number": "01300794",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1176750949",
    "name": "هذال حبنان بن فهد الدوسري",
    "number": "01300795",
    "room": "42",
    "location": "رابع 2",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0150754738",
    "name": "احمد حسين  تينه",
    "number": "01300741",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1180289488",
    "name": "باني مبارك باني الدوسري",
    "number": "01300743",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0020237472",
    "name": "حمود محمد شوعي عتين",
    "number": "01300746",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1179856834",
    "name": "رسام مهل بن محمد الدوسري",
    "number": "01300748",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1179883655",
    "name": "سعود مناحي بن بتال الدوسري",
    "number": "01300749",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1173999861",
    "name": "سلطان فهد عبدالله الشهراني",
    "number": "01300751",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1176113569",
    "name": "سلطان هذال بن حارب الدوسري",
    "number": "01300752",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1189130204",
    "name": "طلال علي محمد الدوسري",
    "number": "01300753",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1176457156",
    "name": "عائض سالم غريب الدوسري",
    "number": "01300754",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1178844435",
    "name": "عبدالله مطلق بن عبدالله الدوسري",
    "number": "01300763",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1178121594",
    "name": "علي عبدالله فائز الشهراني",
    "number": "01300768",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1178549679",
    "name": "عنان محمد عنان العرجاني",
    "number": "01300770",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1181464874",
    "name": "فرحان سالم بن عبدالله الدوسري",
    "number": "01300773",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1173895663",
    "name": "فهاد عبدالله حشر المصارير",
    "number": "01300774",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1185678107",
    "name": "فيصل فهد هادي الدوسري",
    "number": "01300778",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0191053606",
    "name": "ماهر محمد منير غزال",
    "number": "01300779",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1176621611",
    "name": "محسن هادي محسن الدوسري",
    "number": "01300780",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0191024585",
    "name": "محمد سامر طاهر رزوق",
    "number": "01300782",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1187992803",
    "name": "محمد سعد محمد الدوسري",
    "number": "01300783",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0191061186",
    "name": "محمد عامر طاهر رزوق",
    "number": "01300786",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "0160241895",
    "name": "محمد علي عبدالله السعيدي",
    "number": "01300787",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1195545320",
    "name": "محمد هباش سمره آل معيلي",
    "number": "01300788",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1181975234",
    "name": "محياء فهد محياء الدوسري",
    "number": "01300789",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1179986011",
    "name": "مدباج علي مدباج الدوسري",
    "number": "01300790",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1179516867",
    "name": "مدباج فهاد بن مبارك الدوسري",
    "number": "01300791",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1173031426",
    "name": "مسلي مطلق مسلي الدوسري",
    "number": "01300792",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "4504550338",
    "name": "مشير فواز عبده علي",
    "number": "01300793",
    "room": "41",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  {
    "_id": "1177594999",
    "name": "نايف شجاع غليفص الدوسري",
    "number": "01300795",
    "room": "52",
    "location": "رابع 1",
    "class": "الرابع الابتدائي",
    "school": "القدس الابتدائية"
  },
  /* msarat 24 */
{
    "_id": "1155540402",
    "name": "البندري عمر بن فيحان البقمي",
    "number": "111450001",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1159083870",
    "name": "المى عبدالقادر حسن الشيخي",
    "number": "111450002",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153631591",
    "name": "ألين مروان احمد الفقية العمودي",
    "number": "111450003",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152078000",
    "name": "جمانه بنت حمد بن سعيد الحارثي",
    "number": "111450004",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1161512700",
    "name": "جنى نايف عبدالجليل احمدخليل",
    "number": "111450005",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153367600",
    "name": "جود بنت عبدالله بن عائض بن علي آل صنعاء القرني",
    "number": "111450006",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150525994",
    "name": "حلا محمد بن عصام بن عبدالكريم بخاري",
    "number": "111450007",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1164492918",
    "name": "حنين عبدالرحمن محمد العمري",
    "number": "111450008",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153335243",
    "name": "دانة وليد بن خالد الهمزاني",
    "number": "111450009",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2285329286",
    "name": "دانيه عبدلله غالب الحسني",
    "number": "111450010",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150177283",
    "name": "ديما بنت علي بن مرعي الحصنه الشهري",
    "number": "111450011",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148574344",
    "name": "ربى أيمن بن أحمد الحربى",
    "number": "111450012",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154030025",
    "name": "ربى بنت ناصر بن عثمان بن معيض بني جندب الزهراني",
    "number": "111450013",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150818407",
    "name": "رتيل محمد بن صالح بن عبد الله الحزري الزهراني",
    "number": "111450014",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151588264",
    "name": "رغد بنت علي بن احمد العتيبي",
    "number": "111450015",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148184201",
    "name": "رنيم عبدالرحمن سعد الاسمري",
    "number": "111450016",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151896808",
    "name": "رهف عبدالله محمد العامري",
    "number": "111450017",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146026784",
    "name": "ريتاج سعيد ابن عبيد العلياني",
    "number": "111450018",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154799116",
    "name": "ريتال خالد يحي الصامطي",
    "number": "111450019",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152229116",
    "name": "ريما بنت أحمد بن ضيف الله بن سعيد سدران",
    "number": "111450020",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154382699",
    "name": "سديم عبدالله عطيه الحارثي",
    "number": "111450021",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152163208",
    "name": "شيخه سلطان محمد حسين الصالح",
    "number": "111450022",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1159525920",
    "name": "غلا بنت نايف بن صالح المالكي",
    "number": "111450023",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153688567",
    "name": "لطيفه ناصر سعود المنيعي",
    "number": "111450024",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146393705",
    "name": "لمى ابراهيم بن عبدالله الغامدي",
    "number": "111450025",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151752688",
    "name": "مرام علي محمد الغامدي",
    "number": "111450026",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151574827",
    "name": "مريم عبدالرحمن ابراهيم السويطي",
    "number": "111450027",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152606834",
    "name": "مياس بنت محمد بن علي الشهراني",
    "number": "111450028",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151003694",
    "name": "ميرال مروان كريم خضر",
    "number": "111450029",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150109484",
    "name": "نبراس فيصل عطيه الحربي",
    "number": "111450030",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153506546",
    "name": "ندى بنت احمد بن محمد الشريف",
    "number": "111450031",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154796948",
    "name": "نوران بنت محمد بن شكري بن احمد العيدروس",
    "number": "111450032",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1159083995",
    "name": "نورة عبدالقادر حسن الشيخي",
    "number": "111450033",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141827368",
    "name": "نوره سعد بن منشط بن فريجان الرياحي البقمى",
    "number": "111450034",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1177440334",
    "name": "يارا يحي بن عبده طميحي",
    "number": "111450035",
    "room": "5",
    "location": "أولى اول ",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151038328",
    "name": "اتين توفيق بن محمد اليوبي",
    "number": "111450036",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1160460042",
    "name": "اريام طارق بن محمد بن حسن المغربي",
    "number": "111450037",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2300039597",
    "name": "امنه سعيد محمد بازيد",
    "number": "111450038",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152025498",
    "name": "ألين طارق بن حميد المالكي",
    "number": "111450039",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154182198",
    "name": "تالة صالح بن عبد الله بن محمد السعدي الغامدي",
    "number": "111450040",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144913033",
    "name": "تالين عبدالرحمن ناصر قابض",
    "number": "111450041",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153553845",
    "name": "تالين محمد بن عبدالعزيز الصيادي",
    "number": "111450042",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150769527",
    "name": "جمانه بنت عبدالرحيم بن عويض الحربي",
    "number": "111450043",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152960843",
    "name": "جمانه خالد بن امين زحيري",
    "number": "111450044",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1155300971",
    "name": "جوري ابراهيم بن يوسف بن طاوي",
    "number": "111450045",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153925662",
    "name": "جوري بنت عبد الرحيم بن حزام الزهراني",
    "number": "111450046",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152512560",
    "name": "دانه علي سعيد القحطاني",
    "number": "111450047",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152012991",
    "name": "ديمه بنت محمد بن ابو علامه بن محمد ال حزبان الشهري",
    "number": "111450048",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1171220161",
    "name": "راما محمد بن احمد الزهراني",
    "number": "111450049",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152722334",
    "name": "ربى بنت مساعد بن عبدالله الخيبري",
    "number": "111450050",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154901647",
    "name": "رفيف أحمد يحي حارثي",
    "number": "111450051",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1177829890",
    "name": "ريم محمد عبدالله النخالي",
    "number": "111450052",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151710975",
    "name": "ريماس بنت وحيد بن علي كريري",
    "number": "111450053",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152119093",
    "name": "ريوف عبدالعزيز عمر رافع",
    "number": "111450054",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1161681869",
    "name": "سالي علي احمد الغامدي",
    "number": "111450055",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1161116031",
    "name": "سيرين منصور جبران المولد",
    "number": "111450056",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1164108985",
    "name": "شوق حسين حمد الجحدلي",
    "number": "111450057",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1158229946",
    "name": "فائقه هاني بن عباس بن محمد مقادمي",
    "number": "111450058",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152410674",
    "name": "كنزي بنت فهد بن فرج الله المطيري",
    "number": "111450059",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153681497",
    "name": "لتين حميد حامد الخرماني",
    "number": "111450060",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1155196437",
    "name": "لمار عبدالرحمن مزعل العنزي",
    "number": "111450061",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154188989",
    "name": "لين بدر بخيت الشهراني",
    "number": "111450062",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154892317",
    "name": "لين بكر عبدالله ابوخميس",
    "number": "111450063",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150126785",
    "name": "لين فواز سليمان العنزي",
    "number": "111450064",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154065989",
    "name": "مرح مرشد ابن محمد الزهراني",
    "number": "111450065",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1167517521",
    "name": "منيرة اياد محمد الصائغ",
    "number": "111450066",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149741306",
    "name": "مياده احمد ابن عبدالله الغامدي",
    "number": "111450067",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149387514",
    "name": "ميار احمد محمد البكري",
    "number": "111450068",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154047912",
    "name": "نهال سمير عبدالعزيز عسيري",
    "number": "111450069",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150966420",
    "name": "هياء عامر عبدالله الشهراني",
    "number": "111450070",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1156519132",
    "name": "وتين عامر بن عوض العمراني",
    "number": "111450071",
    "room": "6",
    "location": "أولى ثاني",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1175909264",
    "name": "العنود عادل بن سعيد الجهني",
    "number": "111450072",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1159089364",
    "name": "أريام علي عيسي الضامري",
    "number": "111450073",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148929803",
    "name": "ألمى بنت محمد بن عبدالله الغامدي",
    "number": "111450074",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148939331",
    "name": "بشرى طارق عبدالله الساكتي",
    "number": "111450075",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152299911",
    "name": "جود سعود طائل الدلبحي",
    "number": "111450076",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152985444",
    "name": "جودي هاني زيد الطبيشي",
    "number": "111450077",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151756713",
    "name": "جوري جيلان محمد دواري",
    "number": "111450078",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151556279",
    "name": "حنين احمد حاسن الحارثي",
    "number": "111450079",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152100994",
    "name": "حياة محمد بن فراج الحيدري",
    "number": "111450080",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154100521",
    "name": "ديالا سامي بلقاسم الفقيه",
    "number": "111450081",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151220595",
    "name": "راما بنت فهد بن عبدالعزيز بن عمر الصويتي",
    "number": "111450082",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1173634344",
    "name": "راما غازي محمد باشامياه",
    "number": "111450083",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1161840937",
    "name": "ريلام عبده بن علي بن موسى آل براهيم الشيخي",
    "number": "111450084",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "3837947812",
    "name": "ريم عبدالله سعود بدر",
    "number": "111450085",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153717655",
    "name": "ريم ناصر بن عبدالله بن مجري العمري السبيعي",
    "number": "111450086",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1158752004",
    "name": "ريماس حامد عايد الجهني",
    "number": "111450087",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152660989",
    "name": "سادين محمد عبداللطيف هوساوي",
    "number": "111450088",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153212913",
    "name": "سارة سعيد علي القحطاني",
    "number": "111450089",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152574685",
    "name": "سفانه بنت حازم بن مستور محيا القرشي",
    "number": "111450090",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149505230",
    "name": "عجايب بنت سعيد بن نافع بن لافي الخياري الرشيدي",
    "number": "111450091",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1155538877",
    "name": "غاده محمد مسعود الغامدي",
    "number": "111450092",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149456517",
    "name": "فرح سليمان محمد الحمدان",
    "number": "111450093",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153721236",
    "name": "فرح ماجد سعيد القحطاني",
    "number": "111450094",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152883821",
    "name": "لارا تركي مسفر عسيري",
    "number": "111450095",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146286297",
    "name": "ليان عطاالله حمدي الفارسي",
    "number": "111450096",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152751200",
    "name": "لين ضيف الله احمد الغامدي",
    "number": "111450097",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150615225",
    "name": "مايا وليد بن ثواب بن سويعد المهيميزي الرشيدي",
    "number": "111450098",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150727517",
    "name": "ملك سعيد يحي كعبي",
    "number": "111450099",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1155686668",
    "name": "ملك محمد احمد مندش",
    "number": "111450100",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154650269",
    "name": "ميرال محمد خالد كابلي",
    "number": "111450101",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1158333516",
    "name": "ندى عماد حسن نجار",
    "number": "111450102",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1163494832",
    "name": "نيرسيان وائل محمد بن حسين محمد",
    "number": "111450103",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152531479",
    "name": "همس سلطان جبران خبراني",
    "number": "111450104",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150483970",
    "name": "ولاء سعيد جمعان الغامدي",
    "number": "111450105",
    "room": "7",
    "location": "أولى ثالث",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153678550",
    "name": "ايلاف عبدالله محمد الحربي",
    "number": "111450106",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1155346842",
    "name": "تالين خالد عبدالله بالبيد",
    "number": "111450107",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1163932013",
    "name": "تالين ماجد بن سعيد الشهراني",
    "number": "111450108",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153749773",
    "name": "تولاي عابد بن عبدالله الرايقي",
    "number": "111450109",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154003485",
    "name": "جنى بنت عبدالله بن عامر الغامدي",
    "number": "111450110",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145372221",
    "name": "جوري وحيد ادريس شبعاني",
    "number": "111450111",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1158400299",
    "name": "حنان ناصر عبدالله الغامدي",
    "number": "111450112",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1159705456",
    "name": "حور احمد عبدالله الغامدي",
    "number": "111450113",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153894652",
    "name": "رتيل صالح سالم عبدالسلام",
    "number": "111450114",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153894728",
    "name": "رسيل صالح سالم عبدالسلام",
    "number": "111450115",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153311582",
    "name": "رسيل عبدالله زيد الهزاني",
    "number": "111450116",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153086739",
    "name": "ريفان بكر محمد صالح السمان",
    "number": "111450117",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1158544773",
    "name": "ريماس فهد سعد الأحمدي",
    "number": "111450118",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152957831",
    "name": "سلاف عادل مرضى العنزي",
    "number": "111450119",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2305920866",
    "name": "سيرين جمال علي جلال",
    "number": "111450120",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151388517",
    "name": "شهد نواف بن عبدالعزيز الخريجي",
    "number": "111450121",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152202923",
    "name": "صبا عادل محمد الغامدي",
    "number": "111450122",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150597928",
    "name": "عائشه محمد بن عبدالله عسيري",
    "number": "111450123",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149589218",
    "name": "فاطمة رايدبن ظويهربن صالح المغامسي",
    "number": "111450124",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152276562",
    "name": "فايزة مجدي مسفر المالكي",
    "number": "111450125",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152507784",
    "name": "فرح ماجد بن عبيان بن سعد الاحمدي",
    "number": "111450126",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152065262",
    "name": "لانا مانع ابراهيم الرشيدي",
    "number": "111450127",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154182388",
    "name": "لتين حسن احمد حكمي",
    "number": "111450128",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152249221",
    "name": "لمار عبدالرحمن محمد العطاس",
    "number": "111450129",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150550109",
    "name": "لولؤ عبداللة محسن الكاف",
    "number": "111450130",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1156859751",
    "name": "ليال شادي عبيد العرابي",
    "number": "111450131",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1170035313",
    "name": "لين عيد بن حسن الحربي",
    "number": "111450132",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1156985200",
    "name": "لين ناصر ابن موسى ابن عواد الضميني العنزي",
    "number": "111450133",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1155428293",
    "name": "ليندا عمر احمد بابكير",
    "number": "111450134",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150282687",
    "name": "ملك احمد بن محمود غلام",
    "number": "111450135",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153854987",
    "name": "ميار عادل حمزه حياةالحازمي",
    "number": "111450136",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1155975608",
    "name": "ميراس بنت حسن بن حسن ابن ناصر ال بحني المعشي",
    "number": "111450137",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1162657553",
    "name": "نوره ناصر ضبيب العجمي",
    "number": "111450138",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149734277",
    "name": "همس بنت جمعان بن عطيه العيشه الغامدي",
    "number": "111450139",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151028121",
    "name": "يارا عبدالله عبدالرزاق صادق",
    "number": "111450140",
    "room": "8",
    "location": "أولى رابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153870355",
    "name": "اروى باسل يحي المولد",
    "number": "111450141",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1157330844",
    "name": "اعتدال عماد محمد البيروتي",
    "number": "111450142",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150842688",
    "name": "الجازي عبدالرحمن بن سعد الزهراني",
    "number": "111450143",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151714050",
    "name": "ايلين محمد عواض السحيمي",
    "number": "111450144",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153567696",
    "name": "تالا نايف بن يحيى الغامدي",
    "number": "111450145",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148962598",
    "name": "جنا عبدالله محمد الشمراني",
    "number": "111450146",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154798472",
    "name": "جنى حسين علي الشهري",
    "number": "111450147",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150945135",
    "name": "جنى عبدالعزيز خضر الجدعاني",
    "number": "111450148",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154679102",
    "name": "جود خالد بن مطيران بن سعيد الذبياني الجهني",
    "number": "111450149",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150965620",
    "name": "جود محمد بن صالح الشمراني",
    "number": "111450150",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1158842730",
    "name": "حلا هاني غزاي المطيري",
    "number": "111450151",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152774293",
    "name": "داليا مبارك محمد القحطاني",
    "number": "111450152",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153480726",
    "name": "دينا هاني عبدالله المقيل",
    "number": "111450153",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154368904",
    "name": "راما معلا بن علي السلمي",
    "number": "111450154",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1157406412",
    "name": "رتيل بنت مطر بن عقل السلمي",
    "number": "111450155",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152398341",
    "name": "رسيل عطيةالله محسن العريشي",
    "number": "111450156",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2297306801",
    "name": "رفيف سلطان محمد سلطان",
    "number": "111450157",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1175588167",
    "name": "ريفان محمد سالم الزبيدي",
    "number": "111450158",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1178238034",
    "name": "ريماس خالد محمد باطرفي",
    "number": "111450159",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153653769",
    "name": "ريناد بنت سعد بن عبدالله الرشده العماري",
    "number": "111450160",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1159716628",
    "name": "ساره خالد صابر الغامدي",
    "number": "111450161",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149914267",
    "name": "سوزان سراج محمد الغامدي",
    "number": "111450162",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2294075482",
    "name": "شهد محمد - السعدي",
    "number": "111450163",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1156717926",
    "name": "فاطمة بنت محمد بن علي المسلم",
    "number": "111450164",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151973573",
    "name": "لبنى بنت سعود بن طامي الغامدي",
    "number": "111450165",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153628696",
    "name": "لجين عيظه هلال الزهراني",
    "number": "111450166",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1158703981",
    "name": "لمار اسامه علي ابوعلوه",
    "number": "111450167",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150099370",
    "name": "لمار عبدالله فهد المطيري",
    "number": "111450168",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153214471",
    "name": "لماربنت عادل بن درويش المحوري",
    "number": "111450169",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1172569848",
    "name": "لندا صالح عبدالله الغامدي",
    "number": "111450170",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1155838491",
    "name": "لوجين محمد عمر ابو سبعة",
    "number": "111450171",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153753544",
    "name": "لولوه عمرو عباس خياط",
    "number": "111450172",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152241335",
    "name": "لين سلطان بن عبيد بن خليوى الجعفري المطيري",
    "number": "111450173",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153503204",
    "name": "مزون بكري عبدالله ابو حنش",
    "number": "111450174",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2311436832",
    "name": "موضى عبدلاله مبارك باقطيان",
    "number": "111450175",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1174401701",
    "name": "يارا احمد بن هلال الزهراني",
    "number": "111450176",
    "room": "10",
    "location": "أولى خامس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1155693490",
    "name": "العنود عبدالقادر عبدالله المالكي",
    "number": "111450177",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150518916",
    "name": "الما بنت حسين بن ابراهيم عاشور",
    "number": "111450178",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1157626910",
    "name": "ايلاف بنت خالد بن احمد العمري",
    "number": "111450179",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151887393",
    "name": "ايلان مصطفى بن صالح الشيخ",
    "number": "111450180",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1174727543",
    "name": "أبرار عادل محمود الينبعاوي",
    "number": "111450181",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1140718360",
    "name": "أريام  بنت فائز بن لافي بن عشيش الحمدي",
    "number": "111450182",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152299200",
    "name": "أمل طلال رشيد الجهني",
    "number": "111450183",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152624548",
    "name": "تاله سعود بن مريزيق العليانى",
    "number": "111450184",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1163081167",
    "name": "جنى اسعد انور ابوسليمان",
    "number": "111450185",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150067419",
    "name": "جودي عمر بن عنايةالله الصحفي",
    "number": "111450186",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147425928",
    "name": "جوري احمد عايل محرق",
    "number": "111450187",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153672546",
    "name": "جوري هيثم محمد شاكر",
    "number": "111450188",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151781059",
    "name": "جوري ياسر راشد الظاهري",
    "number": "111450189",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154652851",
    "name": "حور حامد طاهر فلاته",
    "number": "111450190",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151586128",
    "name": "ديالا سلطان بن سعيد بن عجيل الرفاعي",
    "number": "111450191",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153145899",
    "name": "رؤى تركي علي العلياني",
    "number": "111450192",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147425944",
    "name": "رهف احمد عايل محرق",
    "number": "111450193",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1174797124",
    "name": "روينه عدنان سليمان فضل",
    "number": "111450194",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151624994",
    "name": "ريتال ثامر بن ابراهيم الجهني",
    "number": "111450195",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148084393",
    "name": "ريماس عبدالله بن سعيد بن معيض ال بوسحاق الزهراني",
    "number": "111450196",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149780502",
    "name": "ريوف فوزي بن منصور بن احمد حويس الزهراني",
    "number": "111450197",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149831594",
    "name": "سديم بنت عامر بن راجي الصحفي الحربي",
    "number": "111450198",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1162222283",
    "name": "سيلين عادل عبدالرزاق المراكشي",
    "number": "111450199",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1160390447",
    "name": "ضي محمد بن عبده بن محسن زيلع",
    "number": "111450200",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154251779",
    "name": "غلا بندر احمد السقاف",
    "number": "111450201",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151616206",
    "name": "غيداء علي دخيل الله المالكي",
    "number": "111450202",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154600454",
    "name": "لارين مهدي محمد همامي",
    "number": "111450203",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1156016394",
    "name": "ليان وليد بن عبدالرحمن الحميري",
    "number": "111450204",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150141115",
    "name": "لين عمر بن مسعد السلمى",
    "number": "111450205",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149079970",
    "name": "منال عبدالعزيز بن محمد بن عبدالرحمن ال عبدالعزيز العمري",
    "number": "111450206",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1156036517",
    "name": "ميار خالد عبدالله المغربي",
    "number": "111450207",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152302681",
    "name": "ميار عبدالله محمد الصبحي",
    "number": "111450208",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150682456",
    "name": "ميرال عمرو سالم باصحيح",
    "number": "111450209",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149830984",
    "name": "نوف فهد بن عبدالله بن محمد الطفسه الزهراني",
    "number": "111450210",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154207656",
    "name": "هدى تركي ابراهيم عاشور",
    "number": "111450211",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2299600144",
    "name": "هيا علي حسن باقيس",
    "number": "111450212",
    "room": "11",
    "location": "أولى سادس",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152041115",
    "name": "الانا باسم بن محمد بن مقبول الحجوري",
    "number": "111450213",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149688069",
    "name": "الهنوف يوسف ناصر الحارثي",
    "number": "111450214",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154284564",
    "name": "بتلاء مفرج عبدالله البريكي",
    "number": "111450215",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151424999",
    "name": "تاله بنت ابراهيم بن عبدالله بن جابر التوم عسيرى",
    "number": "111450216",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152653133",
    "name": "تسنيم محمد فلاح الحربي",
    "number": "111450217",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152545347",
    "name": "تولين محمد يحى الريمى",
    "number": "111450218",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152422638",
    "name": "جمانة عبدالله بن احمد طرابلسي",
    "number": "111450219",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153618903",
    "name": "جنى خالد ابن محمد الغامدي",
    "number": "111450220",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153198062",
    "name": "جولينا عبدالله بن محمد آل مستور",
    "number": "111450221",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1158365492",
    "name": "حلا سعد محمد الجهني",
    "number": "111450222",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150400933",
    "name": "دانه عبدالرحمن عبدالله القرني",
    "number": "111450223",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153969751",
    "name": "دنيا بنت احمد بن محمد بن عطيه الحسني الزهراني",
    "number": "111450224",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154904377",
    "name": "ديما طارق فرج احمد",
    "number": "111450225",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149880799",
    "name": "رفيف محمد بن راشد بن ثواب الجعفري المطيري",
    "number": "111450226",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2301811762",
    "name": "ريتال خليل محمـد بركات",
    "number": "111450227",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1163117342",
    "name": "ريناد خالد بن منيع الله بن عواد الربيعي",
    "number": "111450228",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2400473654",
    "name": "زين ماجد رزق درويش",
    "number": "111450229",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1168103941",
    "name": "سديم محمد سعد الغامدي",
    "number": "111450230",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149700617",
    "name": "سيدرا عبدالرحمن محمد المحيميد",
    "number": "111450231",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148161431",
    "name": "شادن سعيد مطر الزهراني",
    "number": "111450232",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151709001",
    "name": "غدي علي محمد علوى",
    "number": "111450233",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1155216581",
    "name": "غلاء يوسف يحي الخيري",
    "number": "111450234",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154270522",
    "name": "فاطمه حسين قحصان ال مخلص",
    "number": "111450235",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1164437848",
    "name": "فوزيه محمد بن سالم بن محمد زربان",
    "number": "111450236",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1158141240",
    "name": "فيافي يوسف بن احمد بن عبدالله الصيعري الغامدي",
    "number": "111450237",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150551875",
    "name": "كادي محمد بن مستور بن رده الثبيتي",
    "number": "111450238",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151758909",
    "name": "لجين سمير منصور الحربي",
    "number": "111450239",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1159490786",
    "name": "لجين عبدالله بن احمد بن محمد الصافي الغامدي",
    "number": "111450240",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150444196",
    "name": "ليان بنت ياسر بن سعيد بن عبدالله المعكاني الزهراني",
    "number": "111450241",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154936734",
    "name": "ليليان عبدالمجيد غرم الله الغامدي",
    "number": "111450242",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149938035",
    "name": "لين هاشم احمد الغامدي",
    "number": "111450243",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151435524",
    "name": "لينا صلاح محمد الشهري",
    "number": "111450244",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150738977",
    "name": "ملك مالك بن حماد الشمري",
    "number": "111450245",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151627120",
    "name": "نور حمدان بن سفر بن مسيفر المحمدي",
    "number": "111450246",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151245717",
    "name": "نوف بنت نايف بن مشحن البقمي",
    "number": "111450247",
    "room": "12",
    "location": "أولى سابع",
    "class": "الأول الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145877450",
    "name": "الين هاني منصور دهان",
    "number": "121600001",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146141658",
    "name": "أسيل عبدالله عامر ال ناصر",
    "number": "121600002",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152282685",
    "name": "تولين امين ابراهيم مؤذن",
    "number": "121600003",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143286753",
    "name": "جمانه مصلح محسن المحمادي",
    "number": "121600004",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149163691",
    "name": "جنى سرحان بن أحمد بن محمد آل معيض القرني",
    "number": "121600005",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148422296",
    "name": "جوانا خالد احمد باحسن",
    "number": "121600006",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2386058255",
    "name": "دارين عبدالله حسن حله",
    "number": "121600007",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147618043",
    "name": "دلال عادل منهاج الدين قاسم",
    "number": "121600008",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151114624",
    "name": "رسيل عبدالسلام بن سعد بن محمد آل مرعي القرني",
    "number": "121600009",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141992899",
    "name": "رغده ياسر صالح العبادي",
    "number": "121600010",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153561228",
    "name": "رونس بنت أحمد بن مسفر بن علياء الزهراني",
    "number": "121600011",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144180716",
    "name": "ريتال جمعان بن سعيد بن عبيد الرمثي البيشي",
    "number": "121600012",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154162620",
    "name": "ريتال عبدالمجيد بن احمد بن سعيد ال محفوظ الغامدي",
    "number": "121600013",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150869830",
    "name": "زينه حسين محمد النعمي",
    "number": "121600014",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146546971",
    "name": "سارا علي بن عبد الله بن عثمان ال بن زارع العمري",
    "number": "121600015",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147449290",
    "name": "سديم بنت ياسر بن عبدالله السلمي",
    "number": "121600016",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148181496",
    "name": "سلاف يوسف سعيد الغامدي",
    "number": "121600017",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147500563",
    "name": "علا فهد بن عتيق بن سعد العرابي الحارثي",
    "number": "121600018",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2355719309",
    "name": "غزل نبيل جمال الشيخ يوسف",
    "number": "121600019",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150558938",
    "name": "غلا ابراهيم بن حسن العباسي",
    "number": "121600020",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148107665",
    "name": "غلا هيثم محمد قاري",
    "number": "121600021",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149547026",
    "name": "فاطمه عبدالرحيم عايد المالكي",
    "number": "121600022",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148363623",
    "name": "فجر عبدالله صالح الاختر",
    "number": "121600023",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149029413",
    "name": "فرح مصلح محسن المحمادي",
    "number": "121600024",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148174368",
    "name": "لبنى عبدالله علي القرني",
    "number": "121600025",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149453480",
    "name": "لماربنت فهد بن عامر ال عبدالعزيز عسيري",
    "number": "121600026",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145582654",
    "name": "ليان عزيز رزيق الزهراني",
    "number": "121600027",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147013450",
    "name": "لين مجدي بن منصور بن غالي الصبحي",
    "number": "121600028",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2463316345",
    "name": "محاسن حاتم اسماعيل السبع",
    "number": "121600029",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143999397",
    "name": "مرام احمد سلوم المنتشري",
    "number": "121600030",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2470331923",
    "name": "ملك محمد ناصف فتوح",
    "number": "121600031",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151017397",
    "name": "ميرال تركي سعيد الزهراني",
    "number": "121600032",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "n009729446",
    "name": "ميس محمد علي عباس -",
    "number": "121600033",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148878372",
    "name": "نورة فواز عطيوى الحربي",
    "number": "121600034",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145571194",
    "name": "يارا عبدالله علي عسيري",
    "number": "121600035",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148521105",
    "name": "يارا موفق عبدالفتاح حنيف",
    "number": "121600036",
    "room": "1",
    "location": "ثاني اول",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148487042",
    "name": "آلاء محمد علي اثلاوي",
    "number": "121600037",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2286058587",
    "name": "اهداب طاهر احمد باطهف",
    "number": "121600038",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148885666",
    "name": "أبتسام معيض بن عواض بن معيض الوطيباني المطيري",
    "number": "121600039",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1205573403",
    "name": "أسماء عطية جمعان الغامدي",
    "number": "121600040",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146342033",
    "name": "تالين بنت نايف بن جمعان الزهراني",
    "number": "121600041",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148736679",
    "name": "تقى سعد علي القرني",
    "number": "121600042",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146990534",
    "name": "تولين عبدالله ابن سعد ال رفيع",
    "number": "121600043",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150152047",
    "name": "جنات سامي بن نجيب بن علي شاهين",
    "number": "121600044",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143683298",
    "name": "جنى خميس علىالله فطيني",
    "number": "121600045",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145573463",
    "name": "جوري علي حسن تازي",
    "number": "121600046",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147026064",
    "name": "جوري فهد بن سلطان بن شايد العمري",
    "number": "121600047",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146878804",
    "name": "حلا حسن بن عواد الفايدي الجهني",
    "number": "121600048",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2365676408",
    "name": "حلا لواء الدين محمد ابولبده",
    "number": "121600049",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148792128",
    "name": "خلود بنت عبد الرحيم بن حزام الزهراني",
    "number": "121600050",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146275209",
    "name": "دالين بنت سعد بن سعيد القحطاني",
    "number": "121600051",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148499641",
    "name": "دانه هاني بن محسن الحربي",
    "number": "121600052",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143176293",
    "name": "رزان احمد حسن غروي",
    "number": "121600053",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146415326",
    "name": "رغد علي بن سعد الغامدي",
    "number": "121600054",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145046395",
    "name": "روز عبدالعزيز محمود حلواني",
    "number": "121600055",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148754169",
    "name": "ريماس محمد ابراهيم دغريري",
    "number": "121600056",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149504902",
    "name": "شهد موسى بن مهنا بن احمد آل سعيد العجلاني",
    "number": "121600057",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1158365831",
    "name": "صبا بنت سعيد بن ظافر بن مرزوق آل فهد الحارثي",
    "number": "121600058",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1172886978",
    "name": "غلا عبدالعزيز عبدالله المطيري",
    "number": "121600059",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146657372",
    "name": "غلا يوسف خالد الثقفي",
    "number": "121600060",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145695019",
    "name": "غنى محمد احمد العمري",
    "number": "121600061",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147830408",
    "name": "فرح محمد عبدالعزيز الحارثي",
    "number": "121600062",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1157275593",
    "name": "ليان بنت زكريا بن هادي بن علي مخزم دغريري",
    "number": "121600063",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148686320",
    "name": "ليان بنت محمد بن شكري بن احمد العيدروس",
    "number": "121600064",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148043456",
    "name": "ليان موسى بن محمد بن هندي الاحمدي",
    "number": "121600065",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147566341",
    "name": "ملك سمير بن سلطان بن حسين خوج",
    "number": "121600066",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145603138",
    "name": "منار بنت حمود بن رزيق بن مرزوق المحمادى الحربى",
    "number": "121600067",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146744410",
    "name": "مها صالح سعيد بن صالح آل سالم الغامدي",
    "number": "121600068",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148040759",
    "name": "ميرال عبدالرحمن هاشم المالكي",
    "number": "121600069",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147596751",
    "name": "نسيم بنت نادر بن ادريس شبعاني",
    "number": "121600070",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154812075",
    "name": "وتين خالد محمد حمدي",
    "number": "121600071",
    "room": "2",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146829732",
    "name": "الين سامي بن يحي عيسى",
    "number": "121600072",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2271394310",
    "name": "امجاد ياسين عبدالمجيد احمد",
    "number": "121600073",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "4132914708",
    "name": "أمنية عبد الرحمن حسين هتاري",
    "number": "121600074",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1153144736",
    "name": "بانا ماجد عبدالعزيز عامودي",
    "number": "121600075",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1155313230",
    "name": "تالا محمد حمدان الغامدي",
    "number": "121600076",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2284453525",
    "name": "تسنيم فهمي عبدالمهدي البيلي",
    "number": "121600077",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148619651",
    "name": "جنى فؤاد محمد الفاخوري",
    "number": "121600078",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149150979",
    "name": "جود محمد بن فوزان بن احمد بغدادي",
    "number": "121600079",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148426099",
    "name": "جوري بنت حسين بن عيدان الوادعي",
    "number": "121600080",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149246405",
    "name": "جوري بندر بن عبد الله بن عيسى السعدي الزهراني",
    "number": "121600081",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146105083",
    "name": "جوري صالح حسين الحارثي",
    "number": "121600082",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147053217",
    "name": "جومانا فيصل محمد المحياوي",
    "number": "121600083",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149512582",
    "name": "ديالا احمد عبدالله عسيري",
    "number": "121600084",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151375787",
    "name": "ديالا عايض ابن محمد القرني",
    "number": "121600085",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152319123",
    "name": "ربى يحي احمد حمدي",
    "number": "121600086",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146961071",
    "name": "ريفال بدر بخيت الشهراني",
    "number": "121600087",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2288358753",
    "name": "ريماس محمد أحمد رزق",
    "number": "121600088",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148992744",
    "name": "ريوف أحمد يحي حارثي",
    "number": "121600089",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2382635445",
    "name": "سدرا احمد - حتيتاني",
    "number": "121600090",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147109472",
    "name": "سميرة حمزة بن طلعت بن حمزة بخش",
    "number": "121600091",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1159630829",
    "name": "سوار بنت نادر بن عبدالله بن عبدالحميد صالح",
    "number": "121600092",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149872606",
    "name": "سيلين محمد موفق بن سراج بن عمر كردي",
    "number": "121600093",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149668053",
    "name": "شموخ سعد ابن فاروق محمد",
    "number": "121600094",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "4161932654",
    "name": "غزلان علي محمد الحجوري",
    "number": "121600095",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143886099",
    "name": "لمى ابراهيم ابن فرج الزهراني",
    "number": "121600096",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143886081",
    "name": "ليان ابراهيم ابن فرج الزهراني",
    "number": "121600097",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "3618653590",
    "name": "لين عبد العظيم يحيى الابيض",
    "number": "121600098",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145100135",
    "name": "لين وليد بن ثواب الرشيدي",
    "number": "121600099",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147912552",
    "name": "ملك محمد بن عبدالحليم بن محمد سعيد سيت",
    "number": "121600100",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "5684613",
    "name": "منى عوض محمد عبدالله",
    "number": "121600101",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147836132",
    "name": "ميان محمد بن ابوالفرج التركي",
    "number": "121600102",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154253155",
    "name": "نيفين جنيد عبده حكمي",
    "number": "121600103",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149551739",
    "name": "ورد عماد بن علي الصبحي",
    "number": "121600104",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145789697",
    "name": "وريف مقبول حميدان الثمالي",
    "number": "121600105",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147494684",
    "name": "وفاء بنت عبدالرحمن بن محمد الميموني",
    "number": "121600106",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1161252927",
    "name": "يمنى ايهاب رشاد كعكى",
    "number": "121600107",
    "room": "9",
    "location": "ثاني ثالث",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149915686",
    "name": "العنود بنت علي بن جابر بن علي فردان القحطاني",
    "number": "121600108",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147862898",
    "name": "ألين محمد ابن عبدالله العجرفي",
    "number": "121600109",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145220214",
    "name": "بنان بخيت صالح المالكي",
    "number": "121600110",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149692624",
    "name": "تالا بنت على بن عبدالله الدويش",
    "number": "121600111",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145038152",
    "name": "تالا بنت محمد بن يحي الحسني الزبيدي",
    "number": "121600112",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145003479",
    "name": "تالين سلطان بن عبيد بن خليوي الجعفري المطيري",
    "number": "121600113",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148618851",
    "name": "تالين عبدالله بن عواض الزهراني",
    "number": "121600114",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2361501105",
    "name": "تولين عماد حسين ناصر",
    "number": "121600115",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148234980",
    "name": "تيلاد مهدي محمد همامي",
    "number": "121600116",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147528465",
    "name": "جنى فيصل بن يوسف بن مفرح الفهمي الزهراني",
    "number": "121600117",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149311829",
    "name": "جود داود محمد بن داود",
    "number": "121600118",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147936932",
    "name": "جودي الحسين بن عمر بن محمد دماس",
    "number": "121600119",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1151079587",
    "name": "حلا مستور عبدالواحد الزهراني",
    "number": "121600120",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154296485",
    "name": "دانا فواز بن محمد الفواز",
    "number": "121600121",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154583361",
    "name": "ديالا خالد محمد كابلي",
    "number": "121600122",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150191722",
    "name": "ديما خالد عبدالله السنيدي",
    "number": "121600123",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146182926",
    "name": "راما يوسف بن عبدالله السفياني",
    "number": "121600124",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145660153",
    "name": "رواء بكر محمد صالح السمان",
    "number": "121600125",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148472580",
    "name": "ريما ناصر مفرح السبيعي",
    "number": "121600126",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147848152",
    "name": "سارة مروان محمود حلواني",
    "number": "121600127",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1159597580",
    "name": "سعدى محمد بن عالي بن مثبت العطياني العتيبي",
    "number": "121600128",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144580113",
    "name": "غاده عبدالله بن سعيد بن محمد العبيدي الغامدي",
    "number": "121600129",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148883950",
    "name": "غزلان خلف بن مسفر المالكي",
    "number": "121600130",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149498402",
    "name": "غلا عبدالله محمد الصحفى",
    "number": "121600131",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147525065",
    "name": "لارا عبدالرحمن عبدالعزيز الثقفي",
    "number": "121600132",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "121600108",
    "name": "لانا خالد علي النمر",
    "number": "121600133",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "121600109",
    "name": "لمى محمد عبدالله الزهراني",
    "number": "121600134",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "121600110",
    "name": "ليان انور عثمان الغامدي",
    "number": "121600135",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "121600111",
    "name": "ليان بنت سعد بن عبدالله بن علي الشريف",
    "number": "121600136",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "121600112",
    "name": "ليان علوي عبدالقادر العطاس",
    "number": "121600137",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "121600113",
    "name": "ليان مبارك عبدالله الحمدي",
    "number": "121600138",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "121600114",
    "name": "نالة محمد احمد عسيري",
    "number": "121600139",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "121600115",
    "name": "نرسيان بندر بن زعيم بن بارز المطردي السلمي",
    "number": "121600140",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "121600116",
    "name": "نوف بشير بن شيرمحمد بخش",
    "number": "121600141",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "121600117",
    "name": "وفاء مهدلي محمد الناشري",
    "number": "121600142",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "121600118",
    "name": "يارا علي عبدالله الشهري",
    "number": "121600143",
    "room": "3",
    "location": "ثاني رابع",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1164808048",
    "name": "افنان عبدالعزيز بن حمد بن السريع",
    "number": "121600144",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146723885",
    "name": "ألين سالم بن علي القرني",
    "number": "121600145",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148882739",
    "name": "بيلسان عبدالمجيد غرم الله الغامدي",
    "number": "121600146",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149997544",
    "name": "جوان سلطان بن عبدالعزيز بن محمدسعيد سيت",
    "number": "121600147",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148328808",
    "name": "جيداء بنت مقبل بن زبن الله السلمي",
    "number": "121600148",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146643406",
    "name": "جيداء علي بن محمد عسيلي",
    "number": "121600149",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149845065",
    "name": "حلا حامد عبدالله الغامدي",
    "number": "121600150",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150064572",
    "name": "دالين دخيل عبدالله السعدي",
    "number": "121600151",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152830293",
    "name": "درر احمد عبدالله الغامدي",
    "number": "121600152",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146472665",
    "name": "ذكرى احمد عثمان حكمي",
    "number": "121600153",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143199782",
    "name": "رغد سلمان ثائب المطيري",
    "number": "121600154",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146922875",
    "name": "رند بنت ناصر بن عثمان بن معيض بني جندب الزهراني",
    "number": "121600155",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148027574",
    "name": "رند حمود عائض الحارثي",
    "number": "121600156",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148224932",
    "name": "رولين خالد عثمان عبدلي",
    "number": "121600157",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147939076",
    "name": "ريهام فواز بن عبدالله الزهراني",
    "number": "121600158",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1166714723",
    "name": "زينه نبيل حسين حواس",
    "number": "121600159",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148708447",
    "name": "سارة عادل محمد داود",
    "number": "121600160",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1155703695",
    "name": "سمر سعيد بن احمد بن محمد ال سرور الزهراني",
    "number": "121600161",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149871285",
    "name": "شهد بندر عبدالله الصنعاني",
    "number": "121600162",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146745771",
    "name": "صباح بنت علي بن ناصر باسر",
    "number": "121600163",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148807447",
    "name": "غلا عبدالعزيز عمر الزغيبى",
    "number": "121600164",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1170033334",
    "name": "غندره مراد برهان بنجر",
    "number": "121600165",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146012214",
    "name": "فرح بنت ناهض بن غضبان البلوي",
    "number": "121600166",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145967079",
    "name": "كوثر ابراهيم محمد الميموني",
    "number": "121600167",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1164569947",
    "name": "لمار سلطان بن محمد المضيان",
    "number": "121600168",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147888133",
    "name": "لوجين بنت منصور بن مبارك المولد",
    "number": "121600169",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1155373895",
    "name": "ليلى خليل ابراهيم الهجاري",
    "number": "121600170",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149632307",
    "name": "لين سحيم احمد العسيري",
    "number": "121600171",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147023681",
    "name": "ليندا نواف شاكر العمري",
    "number": "121600172",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149592147",
    "name": "مريم هشام بن ابراهيم أختر",
    "number": "121600173",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150089678",
    "name": "معالي معلا بن ذياب بن عالي المغيضي السلمي",
    "number": "121600174",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148960584",
    "name": "ملامح محمدصالح محمود خان",
    "number": "121600175",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2285936429",
    "name": "مياربنت ماهربن ابراهيم بن لملوم",
    "number": "121600176",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144517701",
    "name": "ميس عبدالعزيز مهدى عسيري",
    "number": "121600177",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146733223",
    "name": "نورة بنت صالح بن علي الشهري",
    "number": "121600178",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148248261",
    "name": "نوف عيد بن حسن الحربي",
    "number": "121600179",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150072146",
    "name": "ود سعد منير احمد",
    "number": "121600180",
    "room": "19",
    "location": "ثاني خامس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1171584335",
    "name": "اجوان محمد بن حسن عسيري",
    "number": "121600181",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148356353",
    "name": "ايلا عبدالرحمن بن سعيد بن مانع القبيسي الشهري",
    "number": "121600182",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146621915",
    "name": "أسيل خالد بن عبدالله الحذيفي",
    "number": "121600183",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "4974671",
    "name": "براءه وليد عبدالعزيز عبدالواسع",
    "number": "121600184",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149349753",
    "name": "بيان نصار عطيه الله المزمومي",
    "number": "121600185",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148781527",
    "name": "تالين عادل عبدالله الحربي",
    "number": "121600186",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2161968660",
    "name": "تولين محمد فخري عمر المعروف دوله",
    "number": "121600187",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1161929136",
    "name": "جنى عبدالله عبدالرحمن القرني",
    "number": "121600188",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146976186",
    "name": "جود عبدالعزيز بن محمد بن جارالله الحسني الزهراني",
    "number": "121600189",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146776024",
    "name": "جوري ضيف الله بن مسفر الزهراني",
    "number": "121600190",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148314154",
    "name": "جوري محمد يحي عسيري",
    "number": "121600191",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150851986",
    "name": "حصه عبدالله بن فرحان بن سليم الفيصل",
    "number": "121600192",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1196111924",
    "name": "دانه احمد عبدالله الداري",
    "number": "121600193",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148973124",
    "name": "رؤى عبدالعزيز رده الحارثي",
    "number": "121600194",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2284937741",
    "name": "ريهام فواز زيد الكلدي",
    "number": "121600195",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147352015",
    "name": "زبيدة محمود عبدالله السليمانى",
    "number": "121600196",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146563455",
    "name": "سارا عبدالله ساعد الزهراني",
    "number": "121600197",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152077135",
    "name": "سيرين سعد بن سعيد بن مجري العدواني الزهراني",
    "number": "121600198",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148582966",
    "name": "شوق عبدالله بن ابراهيم الزبيدي",
    "number": "121600199",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2443402447",
    "name": "طيبة عبدالعزيز علي باسهل",
    "number": "121600200",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "170256988",
    "name": "طيف وضاح عبدالرب البكري",
    "number": "121600201",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144776976",
    "name": "عروبه عبدالعزيز بن حمود بن حميد الطويرقي",
    "number": "121600202",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146692221",
    "name": "غلا علي محمد علوى",
    "number": "121600203",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147039067",
    "name": "غلا محمد بن يحي بن علي مهدي حمدي",
    "number": "121600204",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150282661",
    "name": "غنى احمد محمود غلام",
    "number": "121600205",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146643935",
    "name": "لارين بنت عبد الوهاب بن عبد الغني رجب",
    "number": "121600206",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2561467412",
    "name": "لين امير عبد السيد مدني",
    "number": "121600207",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145967137",
    "name": "لينا بنت عمر بن مسعد الرزمي السلمى",
    "number": "121600208",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154283723",
    "name": "منار بدر رافع الغامدي",
    "number": "121600209",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146677230",
    "name": "ميار عصام حسن عراقى",
    "number": "121600210",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1148895863",
    "name": "ميس محمد بن علي فقيه",
    "number": "121600211",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1175184314",
    "name": "نوره محسن محمد الشهراني",
    "number": "121600212",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2432927073",
    "name": "نوف عمر امين علي",
    "number": "121600213",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2320499169",
    "name": "هنا احمد صبيح سليم",
    "number": "121600214",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147362717",
    "name": "يمنى عامر بن عوض العمراني",
    "number": "121600215",
    "room": "20",
    "location": "ثاني سادس",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "3804541880",
    "name": "اسماء موفق يوسف الشنو",
    "number": "131600001",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1160518849",
    "name": "ايلاف حسن بن علي بن شامي دوح",
    "number": "131600002",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2268787120",
    "name": "أبرار عبداللطيف محمد باريل",
    "number": "131600003",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144195565",
    "name": "أسيل جمعان بن محمد بن عيظه الحميدي الزهراني",
    "number": "131600004",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143040051",
    "name": "تالا حنيش بن حسن بن حسين الهتاني الزهراني",
    "number": "131600005",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1140794783",
    "name": "جنا خالد احمد خليفه",
    "number": "131600006",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141390938",
    "name": "جنى خالدبن حسن بن محسن الشعابي الحارثي",
    "number": "131600007",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142476678",
    "name": "جنى عبد الله بن رشوان بن ناصر سيد صابرين",
    "number": "131600008",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146235997",
    "name": "جود ظافر مانع العمري",
    "number": "131600009",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142281086",
    "name": "دانة بنت سعيد بن علي بن محمد العمري الزهراني",
    "number": "131600010",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144721642",
    "name": "دانه علي بن احمد بن علي الهتاني الزهراني",
    "number": "131600011",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141230936",
    "name": "دانه فايز ناصر الشهري",
    "number": "131600012",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143199758",
    "name": "ديانا رياض بن احمد بن سعيد عثمان",
    "number": "131600013",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2389867587",
    "name": "رحمه عبدالله محمد اسلام غولاحسين",
    "number": "131600014",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144751144",
    "name": "رميس احمد ابن محمد ابن سعيد الجنديي الزهراني",
    "number": "131600015",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2265874707",
    "name": "روان عيسى - محمد يعقوب",
    "number": "131600016",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144522719",
    "name": "ريتاج عبدالله بن احمدبن محمد باروم",
    "number": "131600017",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141462463",
    "name": "ريماس خالد بن محمد بن خلف آل عبدالله الغامدي",
    "number": "131600018",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2259293864",
    "name": "ريماس عادل يحي سليمان",
    "number": "131600019",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154372690",
    "name": "ريماس علي بن عطيه بن حمدان الحسني الزهراني",
    "number": "131600020",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2259017230",
    "name": "سما عادل سالم محمد سالم السوسى",
    "number": "131600021",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146977465",
    "name": "شموخ عبدالله بن احمد بن شوعي قيس",
    "number": "131600022",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2268033566",
    "name": "شهد باسل حسن خليل",
    "number": "131600023",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143737656",
    "name": "فجر بن محمدبن ابوعلامه بن محمد الحزبان الشهري",
    "number": "131600024",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150727483",
    "name": "فجر سعيد بن يحي بن محمد رداش كعبي",
    "number": "131600025",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144998323",
    "name": "فرح علي بن عبدالرحمن بن سعيد الشدوي الزهراني",
    "number": "131600026",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143846101",
    "name": "كناز معتوق بن يحيى بن معيض العبدلي المالكي",
    "number": "131600027",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143986758",
    "name": "لانا هشام بن زاكي بن صويمل اللقماني الحربي",
    "number": "131600028",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142910502",
    "name": "لمار محمد بن عبدالرحمن بن مشني الفهمي الزهراني",
    "number": "131600029",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141446417",
    "name": "لين عبدالله بن مرزوق بن عتيق الشدادي الحارثي",
    "number": "131600030",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142287323",
    "name": "مودة بنت ثامر بن صالح الغامدي",
    "number": "131600031",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "6687628",
    "name": "مي محمود الناصر -",
    "number": "131600032",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145764765",
    "name": "نسرين حماد بن احمد بن سلمان النمري",
    "number": "131600033",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142544426",
    "name": "يارا يوسف بن حامد بن عيضه الطويلي الحارثي",
    "number": "131600034",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143631289",
    "name": "يولفا محسن ابن حماد ابن سنيد الصبحي الحربي",
    "number": "131600035",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149727263",
    "name": "ايلاف هاني بن احمد بن مقبول راجح عاتي",
    "number": "131600036",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149576108",
    "name": "تالا عادل ابن علي ابن حسين خرمي",
    "number": "131600037",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144517917",
    "name": "تالين سامي محمود طيب",
    "number": "131600038",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144205174",
    "name": "تالين ماهربن حامد بن عوده الزايدي الجهني",
    "number": "131600039",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145073357",
    "name": "جوان عبدالله بن محمد بن عايض الحراث القرني",
    "number": "131600040",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2620191",
    "name": "جودي عبد العظيم يحي الابيض",
    "number": "131600041",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141669190",
    "name": "جورى عبدالعزيز بن مساعد بن محمد الفهمي الزهراني",
    "number": "131600042",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1139162562",
    "name": "خديجه بكر بن علي بن عيدروس البار",
    "number": "131600043",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149359984",
    "name": "درر عبدالرحمن بن عبدالله بن سعد آل عثمان القرني",
    "number": "131600044",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143379921",
    "name": "راما خليف بن محمد بن خليف الوهيداني الرشيدي",
    "number": "131600045",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145667141",
    "name": "رنا سعيد بن عطيه بن عبدالله الكناني الزهراني",
    "number": "131600046",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144464870",
    "name": "روهادا نضال بن علي بن عبدالرحمن صباحي",
    "number": "131600047",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141791994",
    "name": "ريتال عبدالحكيم بن عامر بن احمد عسيري",
    "number": "131600048",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141270452",
    "name": "ريفال محمد بن ابو الفرج بن محمد علي التركي",
    "number": "131600049",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147822538",
    "name": "ريم مفرج بن سعيد بن زياد القرشي الزهراني",
    "number": "131600050",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1161591936",
    "name": "ريماس سعد بن احمد بن عوض المالكي",
    "number": "131600051",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2266720164",
    "name": "شذى محمد قايد الوصابي",
    "number": "131600052",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145714299",
    "name": "شهد فهد بن عطيه بن عبدالله الكناني الزهراني",
    "number": "131600053",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1140187277",
    "name": "غلا عبدالقادر بن وازن بن رازن الشيخ",
    "number": "131600054",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143398954",
    "name": "غلا عبدالله بن علي بن محمد منقار قيسي",
    "number": "131600055",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1138286883",
    "name": "غلا غازي بن راشد بن عبدالله مله الغامدي",
    "number": "131600056",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142146057",
    "name": "غلا مطر ابن علي ابن سعيد الجلال الغامدي",
    "number": "131600057",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1139162554",
    "name": "فاطمه بكر بن علي بن عيدروس البار",
    "number": "131600058",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145922611",
    "name": "لانا رابح عبدالعزيز الجهني",
    "number": "131600059",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145447635",
    "name": "لانا عمر بن محمد بن سليم الجويبري المجنوني",
    "number": "131600060",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142843414",
    "name": "لمى ضيف الله عبدالله الزهراني",
    "number": "131600061",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142195880",
    "name": "لمى يوسف بن محمد بن فيصل حاتمي الشريف",
    "number": "131600062",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1140124122",
    "name": "لمياء عبدالله بن فهد بن عقاب الجعفري المطيري",
    "number": "131600063",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145807317",
    "name": "ليان عصام بن حامد بن عوده الزايدي الجهني",
    "number": "131600064",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145213698",
    "name": "لينا مازن بن فهد بن محمد فلمبان",
    "number": "131600065",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1156295931",
    "name": "مدي عبدالله بن عيطه بن  عبدالله الكناني الزهراني",
    "number": "131600066",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144594064",
    "name": "مرام حازم بن احمد الغامدي",
    "number": "131600067",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143804613",
    "name": "ميار سمر بن اسماعيل خدابخش",
    "number": "131600068",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144869128",
    "name": "نوره ماجد بن سحمان بن محمد المكاحله السبيعي",
    "number": "131600069",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1150394417",
    "name": "هدى نواف بن عبدالهادي بن  عبدالحميد الخيفي",
    "number": "131600070",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146533037",
    "name": "ياسمين مرزوق بن عبدربه بن حميد المسافره القرشى",
    "number": "131600071",
    "room": "13",
    "location": "ثالث ثاني",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1138383508",
    "name": "الهنوف صالح محمد الفته",
    "number": "131600072",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141724912",
    "name": "أسيل ريان بن صالح بن سالم باسلامه",
    "number": "131600073",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144466545",
    "name": "أصايل عدنان بن محمود بن بكر أبوعوف الجهني",
    "number": "131600074",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145385546",
    "name": "تولين يوسف بن عبدالعزيز بن مهدي آل عيس الفقيه",
    "number": "131600075",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145213797",
    "name": "جنى محمد بن عبد الرحمن بن حمد الشقير",
    "number": "131600076",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145080105",
    "name": "جوانا عارف بن ظافر بن سلطان الصبحي",
    "number": "131600077",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1166531689",
    "name": "جود احمد بن خالد بن محمد علي",
    "number": "131600078",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2263199701",
    "name": "جودي محمد عبدالرحمن قصبجي",
    "number": "131600079",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2312817899",
    "name": "حلا ابراهيم عبدالله البطراوي",
    "number": "131600080",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1138072184",
    "name": "دانه عبدالله بن خضير بن موسى الحريري العنزي",
    "number": "131600081",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2299594248",
    "name": "دانه عبدالله عبدالرحمن المفلحي",
    "number": "131600082",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149284190",
    "name": "رتال علي بن سليمان بن عمر الصقلاوي",
    "number": "131600083",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1138417058",
    "name": "رغد علي بن حسين بن محمد مشيخي",
    "number": "131600084",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2256691458",
    "name": "روان وليد - سليمان",
    "number": "131600085",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143158663",
    "name": "ريم بنت علي بن احمد العتيبي",
    "number": "131600086",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2265290599",
    "name": "ريماس مسعود علي الدقة",
    "number": "131600087",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145727424",
    "name": "سلطانه عابد بن صالح بن عتيق اليوبي",
    "number": "131600088",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "160514907",
    "name": "سماهر مامون - رشسيد",
    "number": "131600089",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2287338707",
    "name": "شام احمد - اليوسف",
    "number": "131600090",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2267556864",
    "name": "شهد خالد - سليمان",
    "number": "131600091",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "n006944081",
    "name": "صفاء صفوان يوسف حاج محمد",
    "number": "131600092",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147656001",
    "name": "غلا فارس بن مصطفي بن حمزه البوق",
    "number": "131600093",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142595113",
    "name": "في ضيف الله بن احمد بن خلف الله الجاهلي الثقفي",
    "number": "131600094",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1138257728",
    "name": "ليان جمعان بن وران بن مسفر البقمي المالكي",
    "number": "131600095",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143352456",
    "name": "لين محمدبن عبد اللطيف هوساوي",
    "number": "131600096",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142515186",
    "name": "ليندا محمدبن عبدالرحمن بن سالم قحطان الغامدي",
    "number": "131600097",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145674733",
    "name": "ملك خالد بن صالح بن محمد عبوش الغامدي",
    "number": "131600098",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1140779453",
    "name": "منار زينى بن حسن بن زينى متوكل",
    "number": "131600099",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1140779404",
    "name": "ميار زينى بن حسن بن زينى متوكل",
    "number": "131600100",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1158752095",
    "name": "ميان حامد بن عايد بن حامد المرواني الجهني",
    "number": "131600101",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145870463",
    "name": "نوال محمد بن فوزان بن احمد بغدادي",
    "number": "131600102",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2259953954",
    "name": "نورهان فرح فقير طه",
    "number": "131600103",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1155332891",
    "name": "هالة عبدالله سيف الازدى",
    "number": "131600104",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2309332902",
    "name": "هبه ابوبكر احمد الجيلاني",
    "number": "131600105",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144618640",
    "name": "وعد رائد بن محمد بن زيد العمراني الحارثي",
    "number": "131600106",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142720794",
    "name": "الاء لطفي بن عبداللطيف بن عبدالمعطي المغربي",
    "number": "131600107",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149455352",
    "name": "البندري فايز بن عبدالله بن ابراهيم ال علي الشمري",
    "number": "131600108",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "N005778242",
    "name": "ايلاف شاكر - رفاعي",
    "number": "131600109",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142059581",
    "name": "أريام عادل بن راشد بن عتيق الله الرزمي السلمي",
    "number": "131600110",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2255590750",
    "name": "تاله جهاد احمد شعغوط",
    "number": "131600111",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2258330311",
    "name": "جنى فؤاد - سعيد",
    "number": "131600112",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2214928018",
    "name": "حسناء عبد الحنان شاه خان",
    "number": "131600113",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142249612",
    "name": "حلا حامد ابن مقنع ابن عبدالله ال مقنع الغامدي",
    "number": "131600114",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2260406158",
    "name": "حنين سعيد محمد قاسم",
    "number": "131600115",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2265505012",
    "name": "دعاء حسن غلام رسول",
    "number": "131600116",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143198180",
    "name": "رغد بنت ناصر بن عثمان بن معيض بني جندب الزهراني",
    "number": "131600117",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143013959",
    "name": "رنيم عبدالله بن اسماعيل بن يحي الرقيبي المرحبي",
    "number": "131600118",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141117240",
    "name": "روسين عادل بن محمد بن صالح عبوش الغامدي",
    "number": "131600119",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145671705",
    "name": "ريتال كمال بن عبدالرحمن بن امين اخون اخون",
    "number": "131600120",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142257086",
    "name": "ريتال محمد بن احمد بن حمود اليماني",
    "number": "131600121",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141817674",
    "name": "ريم محمد بن صالح بن عبدالله الحسني الزهراني",
    "number": "131600122",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146942923",
    "name": "ريناد علي خلف الشمراني",
    "number": "131600123",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1160801732",
    "name": "سجى فيصل بن عطيه بن محمد الجبلي الغامدي",
    "number": "131600124",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142093945",
    "name": "سديم باسم عبدالرحمن بنجر",
    "number": "131600125",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141411353",
    "name": "شهد عيظه بن احمد بن غرم الله الجندبي الزهراني",
    "number": "131600126",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145251136",
    "name": "طيف علي بن دخيل الله بن صالح المحمدي المالكي",
    "number": "131600127",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144068606",
    "name": "غنى محمد بن صالح بن محمد الكناني الزهراني",
    "number": "131600128",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1139227878",
    "name": "كنان خالدبن عبدالله بن سالم باطرفي",
    "number": "131600129",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143561445",
    "name": "لارا عبدالرحمن بن عبدالله آل ثفيد",
    "number": "131600130",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142223104",
    "name": "لارا عبدالله بن محمد بن غرام الله آل قينان الغامدي",
    "number": "131600131",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2268210065",
    "name": "لانا فواز محمد الشميري",
    "number": "131600132",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2273577052",
    "name": "لما ياسر جميل الهمص",
    "number": "131600133",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146988777",
    "name": "لمى بنت عبدالله بن عامر بن عبدالله عقالا الغامدي",
    "number": "131600134",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2255533834",
    "name": "لينا ناصر حسين سيد",
    "number": "131600135",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154884116",
    "name": "ملك عبدالله بن صالح بن فرج المدفعي",
    "number": "131600136",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147260135",
    "name": "ميار ماجد بن عبدالله بن شارع الموركي البقمي",
    "number": "131600137",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149481473",
    "name": "ميان عصام بن محمد بن دخيل الله الانصاري",
    "number": "131600138",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1127731386",
    "name": "ندى عاطف بن معيض بن محمد الفقعوس القحطاني",
    "number": "131600139",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2263173391",
    "name": "نور انور احمد قنزل",
    "number": "131600140",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144453154",
    "name": "نوف طلال بن مبارك بن جمعان آل حمد الزبيدي",
    "number": "131600141",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144787783",
    "name": "وصايف خالد بن حسن بن محمد الناشري البيشي",
    "number": "131600142",
    "room": "15",
    "location": "ثالث رابع",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "n006687758",
    "name": "اروى محمد الدرويش  ",
    "number": "131600143",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2281262580",
    "name": "اقرا محمد جيد علي",
    "number": "131600144",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143440020",
    "name": "الهام مقبل بن غويتم بن غنيمه المزموي",
    "number": "131600145",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1138844384",
    "name": "الهنوف سالم بن احمد بن محمد المهنوي الهنيدي",
    "number": "131600146",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2261117408",
    "name": "اميرة احمد صالح احمد",
    "number": "131600147",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2274964838",
    "name": "ايناس فريد مولوي عبدالسلام",
    "number": "131600148",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142776481",
    "name": "أريام محمد بن احمد بن محمد الجاهلي الزهراني",
    "number": "131600149",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141438463",
    "name": "أصايل احمد بن سعيد بن غرم الله الحسني الزهراني",
    "number": "131600150",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2368416968",
    "name": "بشرى عبدي عيسى محمود",
    "number": "131600151",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144367636",
    "name": "تلاد فهد احمد زبيدي",
    "number": "131600152",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "4431683",
    "name": "جنى عبدالبصير عبدالجليل سرور",
    "number": "131600153",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145512354",
    "name": "جود بندر بن احمد بن عبدالرزاق السقاف",
    "number": "131600154",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143063004",
    "name": "رسيل محمد بن حنش بن حسن المانع الغامدي",
    "number": "131600155",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2282141775",
    "name": "رنيم هاني سالم عمرباهبري",
    "number": "131600156",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1140325307",
    "name": "ريتاج عبدالعزيز بن عوض بن عمار الجعيد",
    "number": "131600157",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142867660",
    "name": "ريتال فوزي بن محيسن بن مسعد اللهيبي العوفي",
    "number": "131600158",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "n009475675",
    "name": "زينة محمد بلال الزلق",
    "number": "131600159",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2236845281",
    "name": "سلمى محمد - فرج",
    "number": "131600160",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2384209413",
    "name": "سهام محمد بولي عثمان",
    "number": "131600161",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143661575",
    "name": "شذى فهدبن محمدبن علي ال سعيد",
    "number": "131600162",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2365520234",
    "name": "صابرين علي عبدي أبو بكر",
    "number": "131600163",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144460738",
    "name": "صبا محمد دوخي المطيري",
    "number": "131600164",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145922355",
    "name": "عاليه عبدالعزيز سعيد العمري",
    "number": "131600165",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144798228",
    "name": "عذوب خالدبن علي بن محمد آل مصبح العمري",
    "number": "131600166",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146726508",
    "name": "علياء عبدالرحمن بن عامر بن علي القباضي البارقي",
    "number": "131600167",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1140785005",
    "name": "غزل خالد بن علي بن محمد آل مصبح العمري",
    "number": "131600168",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2240290425",
    "name": "فاطمه نظيف بلوله خميس",
    "number": "131600169",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142914975",
    "name": "فجر سعيدبن عبدالرحمن بن محمد الشهري",
    "number": "131600170",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2369465436",
    "name": "قمر عبدالرحمن بولي احمد",
    "number": "131600171",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2256443660",
    "name": "كنزي وليد علي سالم",
    "number": "131600172",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2263493286",
    "name": "لمى احمد محمد العسلي",
    "number": "131600173",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141333672",
    "name": "ليان بجاد بن سلطان بن شايد البدراني العمري",
    "number": "131600174",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2272117066",
    "name": "ليان عبدالاله مبارك باقطيان",
    "number": "131600175",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144933270",
    "name": "مزون تركي ابن سعيد الغامدي",
    "number": "131600176",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142692043",
    "name": "نوران نايف بن محمد بن حسن الجعال الغامدي",
    "number": "131600177",
    "room": "16",
    "location": "ثالث خامس ",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2270788637",
    "name": "اريج هادي احمد مستور",
    "number": "131600178",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143866216",
    "name": "ايلاف عمرو سالم باصحيح",
    "number": "131600179",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141372738",
    "name": "أصايل عبدالرحمن علي سرور",
    "number": "131600180",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2263737765",
    "name": "جمانة سيف الله - كفاية الله",
    "number": "131600181",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2275707483",
    "name": "جنى عماد طاهر قاسم",
    "number": "131600182",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2273780516",
    "name": "حلا يوسف صالح سالم",
    "number": "131600183",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143637898",
    "name": "دانه عبدالله سالم باوزير",
    "number": "131600184",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144373774",
    "name": "ديالا علي بن عمر سليمانى",
    "number": "131600185",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142450400",
    "name": "رانسي فهد بن محمد الصحفي",
    "number": "131600186",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2264935582",
    "name": "رتال عبدالله ابوبكر باعمور",
    "number": "131600187",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1160792287",
    "name": "رفا حاتم بن عبدالغني بن اسماعيل راضي",
    "number": "131600188",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143225454",
    "name": "رواسي علي بن عثمان بن علي مسملي",
    "number": "131600189",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143268785",
    "name": "ريم عادل بن سعيد بن ابراهيم الجرداء الجهني",
    "number": "131600190",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144522974",
    "name": "ريما ايمن بن عبدالغني بن محمد حجاج",
    "number": "131600191",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146008477",
    "name": "ريماس خالد محمدصالح الخويطري",
    "number": "131600192",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2275456248",
    "name": "ريماس محمد احمد حسين",
    "number": "131600193",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142795739",
    "name": "ريماس هشام بن عباس بن محي الدين بخاري",
    "number": "131600194",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142980620",
    "name": "ساره هيثم بن محمد بن محي الدين مليباري",
    "number": "131600195",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142748647",
    "name": "سلاف عوض بن عبدالله بن عوض آل صيفي القرني",
    "number": "131600196",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144486964",
    "name": "سلوان عادل بن بدر بن بخيت المولد",
    "number": "131600197",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1154298127",
    "name": "سوسن احمد ابن صالح ابن محسن العدواني الزهراني",
    "number": "131600198",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145669758",
    "name": "شمعه موسى مهنا العجلاني",
    "number": "131600199",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149654897",
    "name": "عائشه بنت عدنان بن امين شيبي",
    "number": "131600200",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141984623",
    "name": "عهد عبدالله بن احمد بن جابر جغمي شراحيلي",
    "number": "131600201",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143280665",
    "name": "غيداء نعمان بن محمد بن عيسى فلاته",
    "number": "131600202",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144432174",
    "name": "فاطمه محمد بن علي بن يوسف دغريري",
    "number": "131600203",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2271340032",
    "name": "فتحيه فادي يوسف هنيه",
    "number": "131600204",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144784426",
    "name": "لمار محمد بن عبدالله بن سعد ال مسعد القرني",
    "number": "131600205",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145935357",
    "name": "ليان علي صالح الزهراني",
    "number": "131600206",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142063112",
    "name": "مصباح سمير بن سلطان بن حسين خوج",
    "number": "131600207",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144914676",
    "name": "ملاذ محمد بن حسين بن حسن المحمدي المالكي",
    "number": "131600208",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "N003473803",
    "name": "منى فراس عمار عباره",
    "number": "131600209",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1149654962",
    "name": "نبيله بنت عدنان بن امين شيبي",
    "number": "131600210",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144531405",
    "name": "نوره بنت هاشم بن حامد بن احمد الفقيه الغامدي",
    "number": "131600211",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146281595",
    "name": "نوره عبدالعزيز ابراهيم الزعاقي",
    "number": "131600212",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144889605",
    "name": "نوره فهد بن علي بن عوض الداري الثقفي",
    "number": "131600213",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141448595",
    "name": "وسن سعيد بن محمد بن سعيد صالح",
    "number": "131600214",
    "room": "17",
    "location": "ثالث سادس",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144374509",
    "name": "اسرار خالد بن منيع الله بن عواد الربيعي",
    "number": "131600215",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145811806",
    "name": "الريم احمد ابن علي بن حامد المرواني",
    "number": "131600216",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144574504",
    "name": "تولين نابف بن زويد بن محمد علي السالمي",
    "number": "131600217",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2265608857",
    "name": "جمانه جعفر سيد محمد",
    "number": "131600218",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145824601",
    "name": "جميله نواف بن محمد بن صالح المشيقح",
    "number": "131600219",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2260546227",
    "name": "جنى - - السوسي",
    "number": "131600220",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143666764",
    "name": "جنى فهد بن محمد بن   سالم باجهموم",
    "number": "131600221",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1160750566",
    "name": "حصة حمد بن حمدان بن عبد الله السريع",
    "number": "131600222",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143300943",
    "name": "خديجة بنت ريان بن احمد بن عبد الرحمن باموسى العمودي",
    "number": "131600223",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143278255",
    "name": "رند بندر بن عوض بن صنيتان الخراص العتيبي",
    "number": "131600224",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2274270426",
    "name": "رهام علي حسن باقيس",
    "number": "131600225",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1152077424",
    "name": "روا ادهم عبدالغفور احمد قاري",
    "number": "131600226",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145044705",
    "name": "ريفال غازي بن تحسين بن عبدالله سقاف",
    "number": "131600227",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145024723",
    "name": "ريم عادل بن محمد بن حامد المحي الغامدي",
    "number": "131600228",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2223337383",
    "name": "ريم محمد سعيد مشرع",
    "number": "131600229",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144921598",
    "name": "ريمان محمد بن احمد بن محمد صالح الشيخ الانصاري",
    "number": "131600230",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1142123478",
    "name": "ريناد عصام ابن مهيوب ابن محمد سيف",
    "number": "131600231",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145236566",
    "name": "سما ربيع بن مرزوق بن سعيد الرفاعي الجهني",
    "number": "131600232",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141734663",
    "name": "شهد يوسف بن محمد بن هارون الهوساوي",
    "number": "131600233",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1146697345",
    "name": "صبا طلال بن يوسف بن محمد منصور",
    "number": "131600234",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1147260705",
    "name": "علياء جمال بن احمد بن حمدان الاحمدى",
    "number": "131600235",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145749832",
    "name": "غيداء عبدالله عوده البلادي",
    "number": "131600236",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1165341296",
    "name": "فاطمه حسن بن محمد بن عبدرب الرسول عباس",
    "number": "131600237",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143933461",
    "name": "لمار عبدالحكيم بن عبدالله بن حمدان السريع",
    "number": "131600238",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144626320",
    "name": "لمار عبدالله بن عبدالقادر بن عبدالخالق بخاري",
    "number": "131600239",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1143535555",
    "name": "لمى محمدبن سعدبن محمد ال دوبح الغامدي",
    "number": "131600240",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2256099850",
    "name": "ليان حسني بن حسين شكوكاني",
    "number": "131600241",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1145483978",
    "name": "ليان ضيف الله ظافر الغامدي",
    "number": "131600242",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1141443836",
    "name": "ليان فهد بن عبدالله بن سريع السريع",
    "number": "131600243",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1156985093",
    "name": "ليان ناصر ابن موسى ابن عواد الضميني العنزي",
    "number": "131600244",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144697495",
    "name": "ميار باسم بن علي بن ولي حكمي",
    "number": "131600245",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1140149525",
    "name": "ميار حسن بن سالم بن محمد عامر",
    "number": "131600246",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2314153319",
    "name": "نادين اسامة عبدالله مقبول",
    "number": "131600247",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144013602",
    "name": "ندى محمد بن عيد المشدق الجهني",
    "number": "131600248",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1144839253",
    "name": "وسن احمد سعيد الغامدي",
    "number": "131600249",
    "room": "18",
    "location": "ثالث سابع",
    "class": "الثالث الثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1020629208",
    "name": "اماني عبدالله علي المقحزي",
    "number": "121600216",
    "room": "2",
    "location": "ثاني ثاني",
    "class": "ثاني ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2432723464",
    "name": "البتول محمد ابراهيم حسين",
    "number": "131600250",
    "room": "4",
    "location": "ثالث اول",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "2065488468",
    "name": "ايمان عبدالله - العطاس",
    "number": "131600251",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  {
    "_id": "1052419114",
    "name": "بسمه مبارك صالح المولد",
    "number": "131600252",
    "room": "14",
    "location": "ثالث ثالث",
    "class": "ثالث ثانوي",
    "school": "الثانوية الرابعة والعشرون - مسارات"
  },
  /* 14/06/2026 */
  {
    "_id": "1166801298",
    "name": "آمير صالح احمد الغامدي",
    "number": "1000",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4136719780",
    "name": "أحمد عدنان أحمد حمود",
    "number": "1001",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162916165",
    "name": "أمير شادي طارق مجاهد",
    "number": "1002",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2365349964",
    "name": "أنس امين محمد الذيفاني",
    "number": "1003",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166611002",
    "name": "أنس عبدالرحمن عبيدالله المصباحي",
    "number": "1004",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162448425",
    "name": "أنس فواد حسن الحازمي",
    "number": "1005",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162916231",
    "name": "أنمار شادي طارق مجاهد",
    "number": "1006",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164001941",
    "name": "أوس احمد عبدالرحيم عبده",
    "number": "1007",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2398817771",
    "name": "احمد رحيم الله عبدالرشيد عبدالقادر",
    "number": "1008",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2364051355",
    "name": "احمد صلاح صالح الهيج",
    "number": "1009",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165314509",
    "name": "احمد عدنان عايش القريقري",
    "number": "1010",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0160762328",
    "name": "احمد علي احمد قراضه",
    "number": "1011",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0160766139",
    "name": "احمد علي ناصر حسين",
    "number": "1012",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165611367",
    "name": "اصيل عيسي زارع العلاطي",
    "number": "1013",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "9683759295",
    "name": "البراء محمد علي احمد",
    "number": "1015",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162236325",
    "name": "الوليد خالد علي الغامدي",
    "number": "1016",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2330973757",
    "name": "الياس احمد مطهر العمودي",
    "number": "1017",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2368345258",
    "name": "امير طارق ابراهيم النجار",
    "number": "1018",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2349520003",
    "name": "انس اسلام الدين ملا خان",
    "number": "1019",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0160480848",
    "name": "انس بندر محمد البراري",
    "number": "1020",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162068447",
    "name": "انس ياسر مبروك المولد",
    "number": "1021",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2363909397",
    "name": "اياد محمد يونس طوطح",
    "number": "1022",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1172417188",
    "name": "اياد مروان خليف الحصيني",
    "number": "1023",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167323599",
    "name": "باتل رائد عبده الحميري",
    "number": "1024",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164766162",
    "name": "باسل محمد عاطي الحربي",
    "number": "1025",
    "room": "1",
    "location": "أولى ثاني",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1169134754",
    "name": "بتال فهد بن رشيد المجنوني",
    "number": "1026",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165270768",
    "name": "بدر سلطان مبارك العنزي",
    "number": "1027",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165340678",
    "name": "بدر غازي عفين السلمي",
    "number": "1028",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165291582",
    "name": "بدر محمد صالح الشمراني",
    "number": "1029",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2474310717",
    "name": "بسام هادي عوض عبدالله",
    "number": "1030",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1194417257",
    "name": "بندر احمد علي الصومالي",
    "number": "1031",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166330926",
    "name": "جواد ماجد عتيق الصريصري",
    "number": "1032",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162945776",
    "name": "جواد محمد على القرني",
    "number": "1033",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164884890",
    "name": "حاتم حسن بن علي عسيري",
    "number": "1034",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167523099",
    "name": "حازم عبدالمحسن سالم العمرى",
    "number": "1035",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1187565955",
    "name": "حامد غالي حامد الحارثي",
    "number": "1036",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166849040",
    "name": "حسام عبدالله محمد عبيري",
    "number": "1037",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4132475114",
    "name": "حسن حسين سعيد بادكوك",
    "number": "1038",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167862794",
    "name": "حسين راجي حسين باحشوان",
    "number": "1039",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165300219",
    "name": "حمزة ريان يوسف الخوتاني",
    "number": "1040",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2302057357",
    "name": "حمزه عبداللة محمد لغدل",
    "number": "1041",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166904704",
    "name": "خالد حمد هادي اليامي",
    "number": "1042",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164470195",
    "name": "خالد على احمد الهجيني",
    "number": "1043",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "99018127",
    "name": "خالد علي عبدالرحيم عبدالمجيد",
    "number": "1044",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1205305665",
    "name": "خطاب عبدالمعين سعيد المالكي",
    "number": "1045",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2402400689",
    "name": "رائد -ابراهيم - شبير",
    "number": "1046",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2354857928",
    "name": "رائد نبيل عبدالله قاسم",
    "number": "1047",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160974323",
    "name": "رازي ابن هاني ابن صالح فقيه",
    "number": "1048",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164113191",
    "name": "راشد محمد ابراهيم حكمي",
    "number": "1049",
    "room": "2",
    "location": "اولى رابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1172361204",
    "name": "راشد وليد بن عمر لحظه",
    "number": "1050",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161262454",
    "name": "راكان ابراهيم حسن الشمراني",
    "number": "1051",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160414510",
    "name": "راكان بن عبدالرحمن بن عبدالله العمري",
    "number": "1052",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2329278218",
    "name": "رامز فهمي احمد مهيوب",
    "number": "1053",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0010766156",
    "name": "رامي رامز يوسف الغرباوي",
    "number": "1054",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164518241",
    "name": "ريان احمد محمد المزمومي",
    "number": "1055",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164370452",
    "name": "ريان وائل عائض المالكي",
    "number": "1056",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163293408",
    "name": "زايد سعد زايد المالكي",
    "number": "1057",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166518967",
    "name": "زياد سامي محمد المالكي",
    "number": "1058",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1181151919",
    "name": "زياد فهد راضي الفارسي",
    "number": "1059",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165492008",
    "name": "زياد مطرب بن جعيثن الشمري",
    "number": "1060",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163717729",
    "name": "ساري محمد احمد براشى",
    "number": "1061",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2362488906",
    "name": "سالم مبارك سالم عيشان",
    "number": "1062",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2369429960",
    "name": "سالم يسلم سالم باخيضر",
    "number": "1063",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4154700274",
    "name": "سامي عمر سامي اليوسفي",
    "number": "1064",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2120387745",
    "name": "سرور ماجد مبروك باحبجة",
    "number": "1065",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2342791502",
    "name": "سعد صالح محسن باقادر",
    "number": "1066",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1168613576",
    "name": "سعود سعد سعود السميري",
    "number": "1067",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1169504691",
    "name": "سعود عبدالعزيز محمد الغامدي",
    "number": "1068",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164046789",
    "name": "سعود عبدالله سعيد الجيلاني",
    "number": "1069",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2427429218",
    "name": "سعود فراس - عكله",
    "number": "1070",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1174089472",
    "name": "سعيد مسحل سعيد العتيبي",
    "number": "1071",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167106085",
    "name": "سلطان حسين عبدالله المسرحى",
    "number": "1072",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165861806",
    "name": "سلطان عبدالعزيز صلاح الحربي",
    "number": "1073",
    "room": "3",
    "location": "اولى خامس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1187920432",
    "name": "سلطان عبدالله عطيةالله الحربي",
    "number": "1074",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166074326",
    "name": "سلطان ماجد صالح المستادي",
    "number": "1075",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2359395429",
    "name": "سليم سعيد صالح محمد",
    "number": "1076",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163844663",
    "name": "سيف رعد حمود الطويرقي",
    "number": "1077",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166183143",
    "name": "سيف محمد عباس السليماني",
    "number": "1078",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "06253894",
    "name": "شادي عبدالباري محمد عبدالخالق",
    "number": "1079",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165280411",
    "name": "صالح رايد امين كردى",
    "number": "1080",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165273481",
    "name": "صالح عبدالله صالح الشمراني",
    "number": "1081",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0160762341",
    "name": "صالح علوي صالح باجيل",
    "number": "1082",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2366958771",
    "name": "صهيب فراس حسن كرم",
    "number": "1083",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4132946031",
    "name": "عبادي حسين صالح هبه",
    "number": "1084",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1172268870",
    "name": "عبدالرحمن ثامر سالم الشمري",
    "number": "1085",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165897610",
    "name": "عبدالرحمن سعيد بن ساعد الفايدي",
    "number": "1086",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2369279027",
    "name": "عبدالرحمن صالح حسن باحسن",
    "number": "1087",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2355747680",
    "name": "عبدالرحمن عبدالقادر سعيد باوزير",
    "number": "1088",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165509496",
    "name": "عبدالعزيز بندر حمادي الحربي",
    "number": "1089",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "tjza$1427307713",
    "name": "عبدالعزيز عادل مصباح بيبي",
    "number": "1090",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163873548",
    "name": "عبدالعزيز فؤاد حمدان العبيدي",
    "number": "1091",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2372125894",
    "name": "عبدالعظيم عبدالله احمد احمد",
    "number": "1092",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162002834",
    "name": "عبدالله بدر عبدالله الرشيدي",
    "number": "1093",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2120392378",
    "name": "عبدالله خالد عبدالله محمد",
    "number": "1094",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165308980",
    "name": "عبدالله خالد محمد المكلاوي",
    "number": "1095",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1172370080",
    "name": "عبدالله سعد احمد القرني",
    "number": "1096",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2357342662",
    "name": "عبدالله سليمان محمد الحجوري",
    "number": "1097",
    "room": "4",
    "location": "اولى سادس",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2364189304",
    "name": "عبدالله صالح عبدالحق بفلح",
    "number": "1098",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167358363",
    "name": "عبدالله عادل مبارك العبيدي",
    "number": "1099",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163259649",
    "name": "عبدالله علي ناصر الغامدي",
    "number": "1100",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162877284",
    "name": "عبدالله مازن يحي باحسن",
    "number": "1101",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163368523",
    "name": "عبدالله مسبل ابن محمد العمري",
    "number": "1102",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2372250742",
    "name": "عبدالله مصطفى آدم محمد",
    "number": "1103",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159662863",
    "name": "عبدالمحسن فهد سيف السريحي",
    "number": "1104",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163467077",
    "name": "عبدالمحسن مجدى صالح العوفى",
    "number": "1105",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2357976907",
    "name": "عبدالهادي اسماعيل محمد عبد الرحيم",
    "number": "1106",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167989290",
    "name": "عطاالله محمد عطاالله الفارسي",
    "number": "1107",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166738045",
    "name": "علي راشد حسن الشهري",
    "number": "1108",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163068719",
    "name": "علي سعد علي القرني",
    "number": "1109",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2363719358",
    "name": "علي عبدالرحمن محمد سعيفان",
    "number": "1110",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "54677",
    "name": "علي عبدالله محمد عيسى",
    "number": "1111",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1182986651",
    "name": "علي عيسي علي الشمراني",
    "number": "1112",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2363878220",
    "name": "علي محمد غريب جمعه",
    "number": "1113",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164133462",
    "name": "عماد بن مرعي بن سالم العمري",
    "number": "1114",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166269652",
    "name": "عمار احمد عبدالرحيم فلمبان",
    "number": "1115",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162822926",
    "name": "عمار ياسر مرزوق الذبياني",
    "number": "1116",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167313442",
    "name": "عمر احمد عمر الحربى",
    "number": "1117",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164575357",
    "name": "عمر ايمن امين بالخيور",
    "number": "1118",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2359481690",
    "name": "عمر خالد فوزي البنا",
    "number": "1119",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164543330",
    "name": "عمر خليل علي السيد",
    "number": "1120",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163846411",
    "name": "عمر رحاب محي الدين النعماني",
    "number": "1121",
    "room": "5",
    "location": "اولى سابع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2368995938",
    "name": "عمر عبدالله عبده السودي",
    "number": "1122",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167034295",
    "name": "عمر عبدالله عويض الشيخ",
    "number": "1123",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165192822",
    "name": "عمر علاء راضي الفارسي",
    "number": "1124",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1174953966",
    "name": "عمر مبارك عمر باخشوين",
    "number": "1125",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2395988203",
    "name": "عمر مصطفي عمر باحليس",
    "number": "1126",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "6054467054",
    "name": "فارس علي سعيد بوسعد",
    "number": "1127",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165767672",
    "name": "فارس ماجد علي خليل",
    "number": "1128",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166787018",
    "name": "فايز فادى فايز كمفر",
    "number": "1129",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165135920",
    "name": "فراس علي موسى الغامدي",
    "number": "1130",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164319079",
    "name": "فهد مشرف صالح الشهري",
    "number": "1131",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166072460",
    "name": "فيصل سامي عقيل العتيبي",
    "number": "1132",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167447638",
    "name": "فيصل شريف محمد عطيه",
    "number": "1133",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2356603544",
    "name": "فيصل طالب محمدوهيب سكيك",
    "number": "1134",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164132803",
    "name": "فيصل علي وصل المحياوي",
    "number": "1135",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2369119637",
    "name": "قصي محمود احمد النعيزي",
    "number": "1136",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163944158",
    "name": "كنان محمد كمال رواس",
    "number": "1137",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164652347",
    "name": "كنان منصور ناعم الثقفي",
    "number": "1138",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164530014",
    "name": "مؤيد رياض سعيد الغامدي",
    "number": "1139",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1168928602",
    "name": "متعب مقرن عيظه الحارثي",
    "number": "1140",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1168926887",
    "name": "محسن مقرن عيظه الحارثي",
    "number": "1141",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165678366",
    "name": "محمد بندر عبدالرحمن عبده جياش",
    "number": "1142",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161736473",
    "name": "محمد جاسم محمد المولد",
    "number": "1143",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2464974712",
    "name": "محمد رياض سلمان الخواجه",
    "number": "1144",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2359060650",
    "name": "محمد سالم مبروك باخبيره",
    "number": "1145",
    "room": "6",
    "location": "اولى تاسع",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166604965",
    "name": "محمد سلطان عثمان الرشيدي",
    "number": "1146",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166470755",
    "name": "محمد سلمان بن سليم العويبدي",
    "number": "1147",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1168127890",
    "name": "محمد عبدالرحيم بن سعيد العمري",
    "number": "1148",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162007825",
    "name": "محمد عبدالله صالح الغامدي",
    "number": "1149",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164693259",
    "name": "محمد على ابوطالب هزازي",
    "number": "1150",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2443071002",
    "name": "محمد عمرو محمد النميرى",
    "number": "1151",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167207438",
    "name": "محمد فلاح صالح الفارسي",
    "number": "1152",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0160765650",
    "name": "محمد قاسم محمد علي",
    "number": "1153",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165634203",
    "name": "محمد منير صالح الثبيتي",
    "number": "1154",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "9683616966",
    "name": "محمد موسى محمد حميد",
    "number": "1155",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167534542",
    "name": "محمد هتان محمد الغروي",
    "number": "1156",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164647370",
    "name": "محمود عبده ابراهيم دراج",
    "number": "1157",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167291093",
    "name": "مراد احمد طلال كلكتاوي",
    "number": "1158",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163480526",
    "name": "مراد احمد علي الخيري",
    "number": "1159",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161478860",
    "name": "مراد فوزي بن عايض الحارثي",
    "number": "1160",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2383821101",
    "name": "مرسال باسم احمد برعي",
    "number": "1161",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2374290670",
    "name": "مروان سعيد سليمان سعدون",
    "number": "1162",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163705435",
    "name": "مشاري احمد بن حسن الغامدي",
    "number": "1163",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165288687",
    "name": "مشاري سامي عوده الجهني",
    "number": "1164",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164505701",
    "name": "مشاري عايد فهيد المطيري",
    "number": "1165",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163784802",
    "name": "مشاري محمد عوضه ال عبود",
    "number": "1166",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1181561018",
    "name": "مشعل خالد يعن الله الغامدي",
    "number": "1167",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2342642200",
    "name": "مصطفى طيفور مصطفى محمد",
    "number": "1168",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165533512",
    "name": "مهند احمد محمد الحجيلي",
    "number": "1169",
    "room": "7",
    "location": "اولى عاشر",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1148832023",
    "name": "أحمد حسين علي مزيد",
    "number": "2000",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159534963",
    "name": "أحمد صالح لافي الغامدي",
    "number": "2001",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159032737",
    "name": "أحمد على ابوطالب هزازي",
    "number": "2002",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159654084",
    "name": "أنس عبدالرحمن بن عبدالله القرني",
    "number": "2003",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "6073942295",
    "name": "إبراهيم خالد ابو بكر البيتي",
    "number": "2004",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2321429645",
    "name": "ابراهيم امين محمد البربري",
    "number": "2005",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162608044",
    "name": "ابراهيم منير صبحي الاشهب",
    "number": "2006",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160835375",
    "name": "ابراهيم نافع مبارك الشمري",
    "number": "2007",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159741675",
    "name": "احمد بدر بن علي المعيرفي",
    "number": "2008",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "tjza$1427330913",
    "name": "احمد بدر غالب احمد",
    "number": "2009",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161935687",
    "name": "احمد سعيد صالح الغامدي",
    "number": "2010",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2354066363",
    "name": "احمد صالح مبارك العولقي",
    "number": "2011",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160573174",
    "name": "احمد عادل بن احمد القرني",
    "number": "2012",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0190797109",
    "name": "احمد عبدالسلام - محسن",
    "number": "2013",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1181552173",
    "name": "احمد عبدالعزيز سالم اليامي",
    "number": "2014",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164529198",
    "name": "احمد محمد احمد الثقفي",
    "number": "2015",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160078158",
    "name": "اسامة ماجد بن علي الزهراني",
    "number": "2016",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2334816093",
    "name": "اسامه جميل احمدكامل فياض",
    "number": "2017",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160570683",
    "name": "اسامه هاني بن ابراهيم الغامدي",
    "number": "2018",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2365133731",
    "name": "اسامه ياسين حسين جعفر",
    "number": "2019",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2435343203",
    "name": "اسماعيل احمد حسن ابكر",
    "number": "2020",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155783770",
    "name": "اصيل عجب هذال البقمي",
    "number": "2021",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162095697",
    "name": "اصيل نبيل احمد عبده",
    "number": "2022",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2331102810",
    "name": "البراء علي محمد الظهره",
    "number": "2023",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155674581",
    "name": "الحسين يحيى الحسين السيد",
    "number": "2024",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159507324",
    "name": "المهنا محمد جاسر الكلثمي",
    "number": "2025",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2329906313",
    "name": "امجد هلال هاشم طالب",
    "number": "2026",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1190861482",
    "name": "امير اسامة جمال تركي",
    "number": "2027",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2329349571",
    "name": "امير رامي - الجندي",
    "number": "2028",
    "room": "8",
    "location": "ثاني اول",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163058520",
    "name": "اوس بدر بن عوض الحربي",
    "number": "2029",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2331706453",
    "name": "اويس ابراهيم محمدخليل السوادي",
    "number": "2030",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162545139",
    "name": "اياد سليمان بن غيث الفايدي",
    "number": "2031",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "6065329426",
    "name": "ايمن اسامه احمد دبوان",
    "number": "2032",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2313218089",
    "name": "ايمن مبارك سالم عيشان",
    "number": "2033",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "8724900001",
    "name": "بدر مرتضى سيف الشرعبي",
    "number": "2034",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162191512",
    "name": "بدر وهيب قابل العوفي",
    "number": "2035",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2345792929",
    "name": "بسام حسام محمدحسن الصالح",
    "number": "2036",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2350429318",
    "name": "تاج الدين احمد - الجندي",
    "number": "2037",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1168534137",
    "name": "تركي شهوان محمد الغامدي",
    "number": "2038",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163087180",
    "name": "ثامر بدر مسعد المطيري",
    "number": "2039",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161060130",
    "name": "جاسم تامر يحي جمعه",
    "number": "2040",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166848430",
    "name": "جسار عبدالله حمد الحمياني",
    "number": "2041",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160400840",
    "name": "جسار محمد بن عمر الزبيدي",
    "number": "2042",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2335798951",
    "name": "جميل ثامر احمد فياض",
    "number": "2043",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2364690285",
    "name": "حاتم علاءالدين  - امين الفتوى",
    "number": "2044",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161714769",
    "name": "حاتم سيف عايض الحارثي",
    "number": "2045",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161344369",
    "name": "حاتم عبدالمحيي بن حجاج السلمي",
    "number": "2046",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2312401850",
    "name": "حارث منصور احمد ناصر",
    "number": "2047",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160646970",
    "name": "حامد عبدالمعطي احمد الجدعاني",
    "number": "2048",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163657149",
    "name": "حسام رزق الله طويلع السلمي",
    "number": "2049",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159633930",
    "name": "حسام علاءالدين حاسن الغامدي",
    "number": "2050",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159275575",
    "name": "حسان ماجد قليل الخميسي",
    "number": "2051",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159581667",
    "name": "حسن يحي بن محمد مباركي",
    "number": "2052",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161997273",
    "name": "حمزة عبدالله محمد العسيري",
    "number": "2053",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "06010821",
    "name": "حمزه رمزي ناجي محمد",
    "number": "2054",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2334745516",
    "name": "حمزه عبده حمزه قاسم",
    "number": "2055",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2339771707",
    "name": "خالدعبدالجبار شعبان مقداد",
    "number": "2056",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162806085",
    "name": "خالد ابراهيم مصطفي العداوي",
    "number": "2057",
    "room": "9",
    "location": "ثاني ثاني",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156867838",
    "name": "آسر انور احمد الغامدي",
    "number": "3000",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157194018",
    "name": "أحمد ارشد حسن اهيف",
    "number": "3001",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155309303",
    "name": "أصيل حسن علي عواجي",
    "number": "3002",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156285817",
    "name": "أصيل عبدالرحمن علي ابوساعد",
    "number": "3003",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155345323",
    "name": "أمير غرم الله ابن يوسف جراد",
    "number": "3004",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155318916",
    "name": "أنس حسن مقبول السفياني",
    "number": "3005",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157645571",
    "name": "أنمار اشرف سليمان باشا",
    "number": "3006",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155892456",
    "name": "أنمار ثامر سليمان البوشي",
    "number": "3007",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158094191",
    "name": "أنمار محمد كمال رواس",
    "number": "3008",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2319429821",
    "name": "ابراهيم اسماعيل سعيد حامد",
    "number": "3009",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158650265",
    "name": "ابراهيم محمد عوض الرفاعي",
    "number": "3010",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2307847687",
    "name": "احسان انور صالح الزبيدي",
    "number": "3011",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1177839550",
    "name": "احمد اكرم صلاح عشماوي",
    "number": "3012",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2366261804",
    "name": "احمد ايمن سليمان العريني",
    "number": "3013",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154171845",
    "name": "احمد حامد علوي العطاس",
    "number": "3014",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2433774557",
    "name": "احمد رشيد مصطفى زاده",
    "number": "3015",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2323451381",
    "name": "احمد سالمين خميس النهدي",
    "number": "3016",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159745650",
    "name": "احمد سامى عليان السهلي",
    "number": "3017",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161935398",
    "name": "احمد عبدالاله بن احمد العوفي",
    "number": "3018",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2559087495",
    "name": "احمد علي احمد الحدادي",
    "number": "3019",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2302709338",
    "name": "احمد مازن محمد عبدالله",
    "number": "3020",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156006874",
    "name": "احمد محمد ابن رشيد المزمومي",
    "number": "3021",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155142142",
    "name": "اسامه علي بن عوض الزهراني",
    "number": "3022",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157305556",
    "name": "اصيل مهند دخيل الله الردادي",
    "number": "3023",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2457691372",
    "name": "البراء ابوسالف ادم مصطفى",
    "number": "3024",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1152902241",
    "name": "المعتصم ياسر مشبب القحطاني",
    "number": "3026",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157116284",
    "name": "الوليد راشد حسن الشهري",
    "number": "3027",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156465732",
    "name": "امين اسامه بن امين الانديجاني",
    "number": "3028",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2338808807",
    "name": "انس محمد سعيد العمودي",
    "number": "3029",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1177839501",
    "name": "اياد اكرم صلاح عشماوي",
    "number": "3030",
    "room": "10",
    "location": "ثاني ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156159822",
    "name": "اياد باسم محمد العوفي",
    "number": "3031",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159625415",
    "name": "اياد بدر ايوب خان",
    "number": "3032",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161294994",
    "name": "اياد جلال محسن الجندلي",
    "number": "3033",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4285500651",
    "name": "اياد عبده جيلان عبده",
    "number": "3034",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155096892",
    "name": "باسل ساري عامر الرفاعي",
    "number": "3035",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156622233",
    "name": "باسل عبدالعزيز محمد الغامدى",
    "number": "3036",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2304576669",
    "name": "بتال بدر عمر القثمي",
    "number": "3037",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155102609",
    "name": "بدر بطيحان عريمط المعبدي",
    "number": "3038",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156322495",
    "name": "بدر بندر حسن النفيعي",
    "number": "3039",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158080943",
    "name": "بدر عزوز عبدالعزيز المطيري",
    "number": "3040",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156042093",
    "name": "بدر فهد دوخى المطيري",
    "number": "3041",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156911800",
    "name": "بدر فهد عطيه الحارثي",
    "number": "3042",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155749375",
    "name": "بديع صالح احمد الغامدي",
    "number": "3043",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156462176",
    "name": "بسام بندر حمادي الحربي",
    "number": "3044",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1152405286",
    "name": "بندر احمد بن عبدالله آل مفرح",
    "number": "3045",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157523661",
    "name": "بندر رعد حمود الطويرقي",
    "number": "3046",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1151494067",
    "name": "بندر عبدالعالم بن مبيريك الفارسي",
    "number": "3047",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157430875",
    "name": "بندر عبدالعزيز صلاح الزبالي",
    "number": "3048",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "11729",
    "name": "بندر عزالدين موسى ابا",
    "number": "3049",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154217184",
    "name": "تركي احمد سعيد المحمادي",
    "number": "3050",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154414203",
    "name": "تركي هاني ابن حسن تازي",
    "number": "3051",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4683443",
    "name": "تميم عصام علي عبيد",
    "number": "3052",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1211850746",
    "name": "تيم سالم محمد الشهري",
    "number": "3053",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1170180994",
    "name": "ثامر غزاى غويزي الروقي",
    "number": "3054",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164112235",
    "name": "ثنيان مشعف ابن عبد الرحمن القحطاني",
    "number": "3055",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156505479",
    "name": "جاسم محمد قبلان السلمي",
    "number": "3056",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0160225733",
    "name": "جلال محمد قاسم الشهري",
    "number": "3057",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159087673",
    "name": "جميل فيصل رياض السليماني",
    "number": "3058",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0160245644",
    "name": "حاشد عبدالمغني عبدالله حمود علي",
    "number": "3059",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0160241471",
    "name": "حسام ادهم عبدالحميد قحطان",
    "number": "3060",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154716904",
    "name": "حسام حمزه عبدالرحمن بخاري",
    "number": "3061",
    "room": "11",
    "location": "ثاني رابع",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2309501910",
    "name": "حسام محمد سعيد العثامنة",
    "number": "3062",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2318431828",
    "name": "حسن احمد حسن عوض",
    "number": "3063",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157455211",
    "name": "حسين حميدان حامد العبيدي",
    "number": "3064",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2308906524",
    "name": "حسين سعيد حسين الرفاعي",
    "number": "3065",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157089051",
    "name": "حمد محمد حمد العيدي",
    "number": "3066",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2323791141",
    "name": "حمزه محي الدين يوسف الاعمي",
    "number": "3067",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156725986",
    "name": "خالد ابراهيم بن مبارك السفري",
    "number": "3068",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161075310",
    "name": "خالد ابراهيم مفرح عسيري",
    "number": "3069",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2275638217",
    "name": "خالد امين عبدالله السنباني",
    "number": "3070",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2336214545",
    "name": "خالد ايمن غالب عبدالله",
    "number": "3071",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155878729",
    "name": "خالد تركي محمد باكسري",
    "number": "3072",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154928673",
    "name": "خالد عبدالله سالم الزهراني",
    "number": "3073",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2318604150",
    "name": "خالد قاسم يوسف الخظمي",
    "number": "3074",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2312055532",
    "name": "خالد محمد صالح حامد",
    "number": "3075",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157334440",
    "name": "خالد واصف محمدصادق علوى",
    "number": "3076",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2324338496",
    "name": "خالد وليد مهيوب الحسامي",
    "number": "3077",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2392564437",
    "name": "داؤود عبدالحي - عبدالمراد",
    "number": "3078",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156291385",
    "name": "داود ابراهيم داود افلح",
    "number": "3079",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2395845254",
    "name": "رائد عبد الله محمود محمد",
    "number": "3080",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1153897457",
    "name": "راشد رياض بن راشد الرويتعي",
    "number": "3081",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155878901",
    "name": "راشد عادل حميد الحربي",
    "number": "3082",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2333994610",
    "name": "راكان سالم احمد منيف",
    "number": "3083",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155690454",
    "name": "راكان عبدالكريم سعد العنزي",
    "number": "3084",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155797101",
    "name": "راكان محمد مرزوق الزبيدي",
    "number": "3085",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157336205",
    "name": "راكان مسعد بن نميان السلمي",
    "number": "3086",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155328436",
    "name": "راكان مهند مغرم العمري",
    "number": "3087",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "3000072926-1",
    "name": "رامي زبير نور حسين خليل الرحمن",
    "number": "3088",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160199913",
    "name": "رامي سامي محمد الغامدي",
    "number": "3089",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160946784",
    "name": "رشود عبدالله رشود الجدعاني",
    "number": "3090",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156372334",
    "name": "ريان طلال حمدان الذبياني",
    "number": "3091",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154158420",
    "name": "زايد راشد محمد اليهيبي",
    "number": "3092",
    "room": "12",
    "location": "ثاني خامس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158080935",
    "name": "زياد عبدالعزيز ابراهيم الجدعاني",
    "number": "3093",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2338186931",
    "name": "زياد عبدالله هارون ابراهيم",
    "number": "3094",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158040699",
    "name": "سالم ثامر سالم الشمري",
    "number": "3095",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155121005",
    "name": "سعود تركي سعود الجهني",
    "number": "3096",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154178188",
    "name": "سعود عبدالله بن حظاظ اليهيبي",
    "number": "3097",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158471290",
    "name": "سعود ناصر سعود المنيعي",
    "number": "3098",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156739326",
    "name": "سعيد عبدالرحيم بن سعيد العمري",
    "number": "3099",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157767284",
    "name": "سلطان عزوز عبدالعزيز المطيري",
    "number": "3100",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1181867746",
    "name": "سلمان مؤيد سلمان العبدالله",
    "number": "3101",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167896172",
    "name": "سلمان ماجد مهل الحربي",
    "number": "3102",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157540301",
    "name": "سليمان محمد سليمان الجحدلي",
    "number": "3103",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156854166",
    "name": "سمير سلطان سمير خوج",
    "number": "3104",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166610954",
    "name": "سهل عبدالرحمن عبيدالله المصباحي",
    "number": "3105",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159942299",
    "name": "سيف بركي بن بركات الكعيكي",
    "number": "3106",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155476508",
    "name": "سيف سلطان احمد الغامدي",
    "number": "3107",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155253428",
    "name": "سيف سلطان مبارك العنزي",
    "number": "3108",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2325638191",
    "name": "سيف محمد سيف قحطان",
    "number": "3109",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2311438341",
    "name": "صبحي يوسف رزق السرحي",
    "number": "3110",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "tjza$1427293908",
    "name": "صهيب أحمد - الزرزور",
    "number": "3111",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2327680340",
    "name": "طلال زياد احمد العفيفي",
    "number": "3112",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155100538",
    "name": "طلعت محمد طلعت الزهراني",
    "number": "3113",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1170060055",
    "name": "ظاهر فهد ظاهر البدير",
    "number": "3114",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2334854706",
    "name": "عادل احمد عادل الحجه",
    "number": "3115",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156598656",
    "name": "عبدالاله فلاح صالح الفارسي",
    "number": "3116",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0160206266",
    "name": "عبدالحكيم احمد محمد حنتوش",
    "number": "3117",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155741091",
    "name": "عبدالحي نعمان عبدالله فيصل",
    "number": "3118",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1152970032",
    "name": "عبدالرحمن بندر عبدالعزيز الثبيتي",
    "number": "3119",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156323519",
    "name": "عبدالرحمن زايد عابد الثقفي",
    "number": "3120",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2304931302",
    "name": "عبدالرحمن طارق جمال الخالدي",
    "number": "3121",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2315324513",
    "name": "عبدالرحمن محمد محمد بهجت المنلا",
    "number": "3122",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158134518",
    "name": "عبدالرحيم جارالله ابن بريد العرابي",
    "number": "3123",
    "room": "13",
    "location": "ثاني سادس",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157594472",
    "name": "عبدالعزيز حاتم عبدالعزيز شلبي",
    "number": "3124",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157515675",
    "name": "عبدالعزيز خالد صلاح الجدعاني",
    "number": "3125",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4130996293",
    "name": "عبدالعزيز سالم محمد النهدي",
    "number": "3126",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2320106921",
    "name": "عبدالعزيز شائف شرف علي",
    "number": "3127",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155003070",
    "name": "عبدالعزيز صالح حسين آل فاضل",
    "number": "3128",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156430629",
    "name": "عبدالعزيز عبدالمحسن عبدالله السيد",
    "number": "3129",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2325689673",
    "name": "عبدالعزيز عمر احمد قواص",
    "number": "3130",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "3979708694",
    "name": "عبدالله ابراهيم محمد الشهري",
    "number": "3131",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157197599",
    "name": "عبدالله احمد حامد العمري",
    "number": "3132",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2311318543",
    "name": "عبدالله احمد عبد حميد",
    "number": "3133",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159476728",
    "name": "عبدالله احمد عطية الله النعماني",
    "number": "3134",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154565426",
    "name": "عبدالله حسن بن غرمان الشهري",
    "number": "3135",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2315862322",
    "name": "عبدالله حسين مبارك عوض",
    "number": "3136",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2384215972",
    "name": "عبدالله سيد بير علي شاه مدثرشاه",
    "number": "3137",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158685196",
    "name": "عبدالله فواد حمدان الشهري",
    "number": "3138",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2324399829",
    "name": "عبدالله قل محمد - عبدالملك",
    "number": "3139",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2311573972",
    "name": "عبدالله مبارك عبداللة باقطيان",
    "number": "3140",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157090323",
    "name": "عبدالله محمد عاطي الحربي",
    "number": "3141",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1153436132",
    "name": "عبدالله منصور يحي الرازحي",
    "number": "3142",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2332760160",
    "name": "عبدالله وليد - فارس",
    "number": "3143",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154129694",
    "name": "عبدالله يحي بن محمد عسيس",
    "number": "3144",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1152887749",
    "name": "عبدالمجيد عبدالرحمن عبدالله الظهراني",
    "number": "3145",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156916445",
    "name": "عبدالمجيد هتان محمد الرافعى",
    "number": "3146",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157066638",
    "name": "عبدالملك نايف عايض الدوسري",
    "number": "3147",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159684016",
    "name": "عبدالهادي حمد عبدالهادي الجدعاني",
    "number": "3148",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2422872941",
    "name": "عبدالواحد شريف حسن نور",
    "number": "3149",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2370510261",
    "name": "عبدالولي محمد بليي عبدي",
    "number": "3150",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154597106",
    "name": "عبدالوهاب رائد عبدالوهاب بديره",
    "number": "3151",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158117802",
    "name": "عبدالوهاب يحى مفرح العسيري",
    "number": "3152",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2313983401",
    "name": "عبيده محمود عادل الحجة",
    "number": "3153",
    "room": "14",
    "location": "ثاني سابع ",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156915355",
    "name": "عزام عمر مرزوق الذبياني",
    "number": "3154",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156414235",
    "name": "عزام عيضه عويض الحارثي",
    "number": "3155",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2322087509",
    "name": "عـبدالله غازي عبدالله اليافعي",
    "number": "3156",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156594721",
    "name": "علي ايمن حميد الخضيري",
    "number": "3157",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156295030",
    "name": "علي معيلي جدوع الحربي",
    "number": "3158",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1153632938",
    "name": "عماد محمد يحيي الجابري",
    "number": "3159",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158212785",
    "name": "عمار حسن بن عطيةالله الصحفي",
    "number": "3160",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157997733",
    "name": "عمار زكريا علي العبيدي",
    "number": "3161",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2316527700",
    "name": "عمار عبدالله علي ابوالحسن",
    "number": "3162",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2316885165",
    "name": "عمار عمر غلام رسول جمالي",
    "number": "3163",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156602946",
    "name": "عمار نايف عوده المرواني",
    "number": "3164",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2340798830",
    "name": "عمر رائد احمد الجمالي",
    "number": "3165",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1153738164",
    "name": "عمر ريان يوسف الخوتاني",
    "number": "3166",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158094423",
    "name": "عمر شريف محمد عطيه",
    "number": "3167",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2308639547",
    "name": "عمر محمد عبدالله ادم",
    "number": "3168",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1153124282",
    "name": "غسان ضيف الله عبيد الجهني",
    "number": "3169",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2392564429",
    "name": "فؤاد عبدالحي - عبدالمراد",
    "number": "3170",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155350695",
    "name": "فارس منصور محمد البشرى",
    "number": "3171",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158648335",
    "name": "فارس نافع مبارك السلمي",
    "number": "3172",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164657817",
    "name": "فراس احمد طلال مرسي",
    "number": "3173",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2303201194",
    "name": "فراس محمد عيظه مخاشن",
    "number": "3174",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2431735261",
    "name": "فضل محمد فضل اليماني",
    "number": "3175",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159259371",
    "name": "فهد مشعل فهد الشمري",
    "number": "3176",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1153676745",
    "name": "فهد وجدي ابن عائش اليهيبي",
    "number": "3177",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154415762",
    "name": "فهد وليد بن مطيع العنبر",
    "number": "3178",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157176486",
    "name": "فيصل بن عبد العزيز بن سليمان العباس",
    "number": "3179",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157392653",
    "name": "فيصل بندر بن عبدالغني الحربي",
    "number": "3180",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154932543",
    "name": "فيصل حسام عويض القريقري",
    "number": "3181",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2305278349",
    "name": "فيصل حسن فريد محسن",
    "number": "3182",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156448936",
    "name": "فيصل خالد عبداللطيف الغامدي",
    "number": "3183",
    "room": "15",
    "location": "ثاني ثامن",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157646215",
    "name": "فيصل سعود عبدالعزيز خوجه",
    "number": "3184",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2293914707",
    "name": "فيصل عبد الحميد محمد علي",
    "number": "3185",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164217604",
    "name": "فيصل عبدالله سعد القثامي",
    "number": "3186",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1153983687",
    "name": "فيصل عبدالله صديق زيد",
    "number": "3187",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155242066",
    "name": "فيصل فهد مستور الحربي",
    "number": "3188",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2287705285",
    "name": "فيصل قل محمد عبد الملك",
    "number": "3189",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155266040",
    "name": "قصي احمد ابن علي الغامدي",
    "number": "3190",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158049237",
    "name": "قصي اشرف ابوبكر عثمان",
    "number": "3191",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2339784437",
    "name": "قصي عبدالعزيز عبدالله بابصيل",
    "number": "3192",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2314048733",
    "name": "قصي محمد الامير السيد ميرغنى",
    "number": "3193",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2317467625",
    "name": "قـصى محمد موسى الشاعر",
    "number": "3194",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2417787997",
    "name": "كرم اسامه محمود سلمان",
    "number": "3195",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155920489",
    "name": "كنان علي بن عبدالله الزهراني",
    "number": "3196",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1152421762",
    "name": "مؤيد عبدالناصر ابوطالب حمدي",
    "number": "3197",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1152190615",
    "name": "مؤيد عصام بن جميل علوي",
    "number": "3198",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162509713",
    "name": "ماجد عبدالله علي الزهراني",
    "number": "3199",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1182619500",
    "name": "ماجد محمد عبدالله الشمراني",
    "number": "3200",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156863662",
    "name": "مازن عادل محمد الزهراني",
    "number": "3201",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157860675",
    "name": "مالك عمر عوض الحربي",
    "number": "3202",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2302347592",
    "name": "ماهر محمد كبير حسين",
    "number": "3203",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2378834432",
    "name": "مبشر عبدالحكم بشرى محمدعلي",
    "number": "3204",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159837135",
    "name": "متعب سامي سراج الزهراني",
    "number": "3205",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2500371410",
    "name": "مجد قصي غالب عابدين",
    "number": "3206",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157131556",
    "name": "محمد احمد عبدالله الغامدي",
    "number": "3207",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166749299",
    "name": "محمد اسامه محمد رضيان",
    "number": "3208",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154829178",
    "name": "محمد اشرف صالح جروان",
    "number": "3209",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1170674434",
    "name": "محمد بندر سالم بارشيد",
    "number": "3210",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156000034",
    "name": "محمد حسن عبدالله صالح",
    "number": "3211",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2064958297",
    "name": "محمد سمرين وليد الديري",
    "number": "3212",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156962977",
    "name": "محمد عبدالعزيز عبدالله الغامدي",
    "number": "3213",
    "room": "16",
    "location": "ثالث اول",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2431411327",
    "name": "محمد عثمان عبد الله آدم",
    "number": "3214",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155631458",
    "name": "محمد علي حسن الشهري",
    "number": "3215",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2322869948",
    "name": "محمد عمر رابح عبدالرحيم",
    "number": "3216",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157846484",
    "name": "محمد غيث رحاب النعماني",
    "number": "3217",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2297886307",
    "name": "محمد فتحي محمد بالعيد",
    "number": "3218",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2351189440",
    "name": "محمد فهد سعيد بن رشيد",
    "number": "3219",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158457349",
    "name": "محمد فهد علي الغامدي",
    "number": "3220",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4714604768",
    "name": "محمد فيصل  العامري",
    "number": "3221",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2297299881",
    "name": "محمد كرم الدين امام الطاهر",
    "number": "3222",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2318985708",
    "name": "محمد محمد فادي - الحموي",
    "number": "3223",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160331334",
    "name": "محمد منصور ابن محمد المنصور",
    "number": "3224",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155729070",
    "name": "محمد يوسف حسن الغامدي",
    "number": "3225",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2319661480",
    "name": "مراد عبده ادريس غريب",
    "number": "3226",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2305677763",
    "name": "مشاري جهاد محمد الثعبان",
    "number": "3227",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159557097",
    "name": "مشاري خالد حامد الجهني",
    "number": "3228",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166629509",
    "name": "مشاري عباس عائض الحارثي",
    "number": "3229",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1151405279",
    "name": "مشاري عبدالله محي الشمراني",
    "number": "3230",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155673971",
    "name": "مشعل ايمن بن وصل الله اللبدي",
    "number": "3231",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2325169692",
    "name": "مصطفى سمير محمد شمعه",
    "number": "3232",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1151804968",
    "name": "مصعب وليد عبدالله عطيوي",
    "number": "3233",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157864842",
    "name": "معتز خلف جودالله السلمى",
    "number": "3234",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "17879-2",
    "name": "معتز سلطان عمر عبدالرحمن",
    "number": "3235",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163505132",
    "name": "ملهم همام عطيه الزهراني",
    "number": "3236",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154508152",
    "name": "مهند خالد سعد العنزي",
    "number": "3237",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2354279511",
    "name": "مهند سعد علي طاهر",
    "number": "3238",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1150386199",
    "name": "نايف منصور احمد مغربي",
    "number": "3239",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2308105846",
    "name": "نعيم محمد حسين غطاس",
    "number": "3240",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155463423",
    "name": "نواف حسن بن محمد الزهراني",
    "number": "3241",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154894610",
    "name": "نواف سلطان سعيد الجحدلي",
    "number": "3242",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157805480",
    "name": "هاني رحاب محي الدين النعماني",
    "number": "3243",
    "room": "17",
    "location": "ثالث ثاني",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167860335",
    "name": "هتان زيد محمد الحمزي",
    "number": "3244",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1172369942",
    "name": "هتان سعد احمد القرني",
    "number": "3245",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154885303",
    "name": "هيثم سعد خلف الزهراني",
    "number": "3246",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155111899",
    "name": "وسام محسن احمد شراحيلي",
    "number": "3247",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1153556210",
    "name": "وسام وحيد احمد الغامدي",
    "number": "3248",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "3000100",
    "name": "وسيم سلمان خالد عمر",
    "number": "3249",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1153724057",
    "name": "وليد صالح دغيمان العنزي",
    "number": "3250",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1150614897",
    "name": "وليد طلال محمد ابوجلاس",
    "number": "3251",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2392564445",
    "name": "وليد عبدالحي - عبدالمراد",
    "number": "3252",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2441707656",
    "name": "وليد علي محمد احمد",
    "number": "3253",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154460156",
    "name": "وليد محمد سالم الغامدي",
    "number": "3254",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156292508",
    "name": "وليد محمود محمدسعيد القريقري",
    "number": "3255",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1153553589",
    "name": "وليد نواف ملفى الحربي",
    "number": "3256",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1149620047",
    "name": "وليد هليل عبدالمغني القرباني",
    "number": "3257",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2329639260",
    "name": "ياسر حميد احمد الشراحي",
    "number": "3258",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2319944696",
    "name": "ياسر عبدالرحمن عوض فهيد",
    "number": "3259",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2316449590",
    "name": "يزن فهد عبدالله مرعي",
    "number": "3260",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154524514",
    "name": "يزن محمد عمر بانبيله",
    "number": "3261",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155718834",
    "name": "يزيد خالد ابن مانع الشهراني",
    "number": "3262",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156703884",
    "name": "يزيد سالم مطيع المعبدي",
    "number": "3263",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1151615315",
    "name": "يزيد سعيد همييل الغامدي",
    "number": "3264",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156034249",
    "name": "يزيد عبدالحميد حمود المطيري",
    "number": "3265",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157987841",
    "name": "يزيد مهران غازي حنبولي",
    "number": "3266",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2311034496",
    "name": "يـوسف ابوبكر محمد خرد",
    "number": "3267",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2313696177",
    "name": "يوسف امين محمد بوحبات",
    "number": "3268",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156690768",
    "name": "يوسف سامي صالح الهلالي",
    "number": "3269",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1154371650",
    "name": "يوسف عبدالله بن سعد العتيبي",
    "number": "3270",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2321227981",
    "name": "يوسف مازن مغيث شريقى",
    "number": "3271",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0160242520",
    "name": "يوسف محمد قاسم القربي",
    "number": "3272",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162095622",
    "name": "يوسف نبيل احمد عبده",
    "number": "3273",
    "room": "18",
    "location": "ثالث ثالث",
    "class": "الثالث المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2334795909",
    "name": "خالد صلاح صالح الهيج",
    "number": "2058",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2322053998",
    "name": "خالد عبدالرحمن مهدي علي",
    "number": "2059",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159569209",
    "name": "خالد عبدالله صديق زيد",
    "number": "2060",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2366734156",
    "name": "خالد عبدالناصر محمد احمد",
    "number": "2061",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2344836990",
    "name": "خالد محمد سعيد شاه",
    "number": "2062",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2440725725",
    "name": "خالد محمد علي العولقي",
    "number": "2063",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164737775",
    "name": "خالد محمد مبيريك القريقري",
    "number": "2064",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162232159",
    "name": "خالد هيثم خالد الوابلي",
    "number": "2065",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158837086",
    "name": "خالد وليد مسفر الغامدي",
    "number": "2066",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4804541029",
    "name": "ذياب هيمان احمد حمود",
    "number": "2067",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2335995805",
    "name": "رائد ابراهيم الصديق حمودي",
    "number": "2068",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2326685746",
    "name": "رائد اكرم عباس باحميد",
    "number": "2069",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4600804944",
    "name": "رائد الخضر عبدالله محمد",
    "number": "2070",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160888291",
    "name": "رائد غرم الله حمدان الزهراني",
    "number": "2071",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2334203771",
    "name": "راكان حامد قاسم مثنى",
    "number": "2072",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2329443259",
    "name": "رامي عدنان - شهاب",
    "number": "2073",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157573435",
    "name": "رواد عبدالرحمن رشدان الازوري",
    "number": "2074",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159524527",
    "name": "ريان احمد سعد الجهني",
    "number": "2075",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4234210104",
    "name": "ريان احمد صالح عبد الغني",
    "number": "2076",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2362847994",
    "name": "ريان احمد صالح مثنى",
    "number": "2077",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1194417273",
    "name": "ريان احمد علي الصومالي",
    "number": "2078",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162531857",
    "name": "ريان اكرم بن صالح النافعي",
    "number": "2079",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158973493",
    "name": "زايد طلال معيوف الجحدلي",
    "number": "2080",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2429583731",
    "name": "زكريا ناظم قحطان عبدالهادي",
    "number": "2081",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161432180",
    "name": "زياد توفيق عبدالهادي الصحفي",
    "number": "2082",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161467988",
    "name": "زياد عمر علي حكمي",
    "number": "2083",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2329587725",
    "name": "زياد محمد عبيد صياد",
    "number": "2084",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158733244",
    "name": "ساري سلطان احمد الغامدي",
    "number": "2085",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4202284586",
    "name": "سالم رئيس مبارك سميدع",
    "number": "2086",
    "room": "19",
    "location": "ثالث رابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159459898",
    "name": "سطام أحمد شكري آل فتاح",
    "number": "2087",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163619727",
    "name": "سطام عبدالله سعد المالكي",
    "number": "2088",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1189385618",
    "name": "سعد توفيق فخري المولد",
    "number": "2089",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156515874",
    "name": "سعد حسن سعد الشهري",
    "number": "2090",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158725786",
    "name": "سعد خالد سعد الاحمدي",
    "number": "2091",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2315274288",
    "name": "سعود صلاح صالح الهيج",
    "number": "2092",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2321379832",
    "name": "سعيد ابوبكر سعيد بادويلان",
    "number": "2093",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1172246991",
    "name": "سعيد راشد سعيدراشد الخزمري الزهراني",
    "number": "2094",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158488369",
    "name": "سعيد سالم عوده المرواني",
    "number": "2095",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1170822645",
    "name": "سلطان محمد زايد المطيري",
    "number": "2096",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "9683651916",
    "name": "سلمان يسلم مثنى ناصر",
    "number": "2097",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2357255658",
    "name": "سليمان محمد حسين جبران محمد",
    "number": "2098",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163358912",
    "name": "سهيل عمرو عطيةالله النجار",
    "number": "2099",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160087860",
    "name": "سينان نايف عبدالمعطى برقه",
    "number": "2100",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155500950",
    "name": "صالح ايمن صالح بيت المال",
    "number": "2101",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1173430073",
    "name": "صالح جارالله بن سعيد الزهراني",
    "number": "2102",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "6073951923",
    "name": "صقر معاذ سيف صالح",
    "number": "2103",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0160477846",
    "name": "عائض منير مرعي الجعيدي",
    "number": "2104",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160075063",
    "name": "عامر عبدالمحسن محمد عبيري",
    "number": "2105",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161674641",
    "name": "عبدالاله علي حسن عسيري",
    "number": "2106",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159414851",
    "name": "عبدالرحمن احمد عبده الغامدي",
    "number": "2107",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161148299",
    "name": "عبدالرحمن خالد ابن سعيد ابوفيه",
    "number": "2108",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157430404",
    "name": "عبدالرحمن عماد مستور الجدعاني",
    "number": "2109",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2342216120",
    "name": "عبدالرحمن محمد - جليلاتي",
    "number": "2110",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1168188611",
    "name": "عبدالعزيز حسن عبدالغني بكري",
    "number": "2111",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158551489",
    "name": "عبدالعزيز خالد سمير عبدالجواد",
    "number": "2112",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161782089",
    "name": "عبدالعزيز على محمد العلاوي",
    "number": "2113",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1174103125",
    "name": "عبدالله عابد شوعي زيلع",
    "number": "2114",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161919996",
    "name": "عبدالله علي عبده سهبي",
    "number": "2115",
    "room": "20",
    "location": "ثالث خامس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2304754217",
    "name": "عبدالله عمر عثمان عيسى",
    "number": "2116",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2553314960",
    "name": "عبدالله محمد حماده شعبان",
    "number": "2117",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161758154",
    "name": "عبدالله محمد سالم الغامدي",
    "number": "2118",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "41620057404",
    "name": "عبدالله محمد عبدالسلام التركي",
    "number": "2119",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157627306",
    "name": "عبدالملك محمد بن احمد الشمراني",
    "number": "2120",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2344178708",
    "name": "عبدالملك محمد سامر - البيطار",
    "number": "2121",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161648496",
    "name": "عدنان علاء عدنان حلاوه",
    "number": "2122",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160861694",
    "name": "عدي ماجد احمد الحربي",
    "number": "2123",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158074052",
    "name": "عزام محمد عاطي الحربي",
    "number": "2124",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164733444",
    "name": "على محمد علي القرني",
    "number": "2125",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0161079579",
    "name": "علي سالم حسين العولقي",
    "number": "2126",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2334477177",
    "name": "علي محمد محمد اسماعيل",
    "number": "2127",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161135718",
    "name": "عمار عبدالاله ماطر العمري",
    "number": "2128",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1156292433",
    "name": "عمر بندر محمد البيشى",
    "number": "2129",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161111974",
    "name": "عمر عبدالرحمن ابن فيصل حنيف",
    "number": "2130",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2315052494",
    "name": "عمر علي عمر البريكي",
    "number": "2131",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161238561",
    "name": "عمر فاروق بن عبدالله بخاري",
    "number": "2132",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2382879076",
    "name": "عمرو فواد منصور علي معروف",
    "number": "2133",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2318898653",
    "name": "عمرو معتصم حسن حسن",
    "number": "2134",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160840037",
    "name": "غيث أحمد سعد المطيري",
    "number": "2135",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2364689840",
    "name": "فارس احمد علي الملاحي",
    "number": "2136",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2323851317",
    "name": "فارس محمد فارس باقيس",
    "number": "2137",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159162575",
    "name": "فهد خالد محمد مقبول",
    "number": "2138",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158020097",
    "name": "فهد عاطف بن حامد الظاهرى",
    "number": "2139",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158799153",
    "name": "فيصل رياض احمد شعبي",
    "number": "2140",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2440379267",
    "name": "فيصل همدان حسن بن طالب",
    "number": "2141",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2356304671",
    "name": "قيس محمد ناصر - الكود",
    "number": "2142",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160562995",
    "name": "كنان همام فاضل بنتن",
    "number": "2143",
    "room": "21",
    "location": "ثالث سادس",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "6061536021",
    "name": "ليث محمد عبدالله العنقر",
    "number": "2144",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2403072610",
    "name": "مؤيد اسامه يوسف حسن",
    "number": "2145",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2334386329",
    "name": "ماجد أحمد ادريس عبدالله",
    "number": "2146",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2408328884",
    "name": "مازن علاءالدين حرب ابوالعراج",
    "number": "2147",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164258244",
    "name": "مالك سلطان عون الله السلمي",
    "number": "2148",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2320686062",
    "name": "محجوب محمد محجوب وراق",
    "number": "2149",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162858680",
    "name": "محسن حمدي محسن العمري",
    "number": "2150",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2325796890",
    "name": "محسن محمد شعبان بنات",
    "number": "2151",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164234831",
    "name": "محمد أحمد حسين الجهني",
    "number": "2152",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162618423",
    "name": "محمد احمد صالح النخلي",
    "number": "2153",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163479379",
    "name": "محمد احمد علي خياط",
    "number": "2154",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2325143317",
    "name": "محمد احمد محمد الزبده",
    "number": "2155",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4202294254",
    "name": "محمد انور محمد منصر",
    "number": "2156",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2452045632",
    "name": "محمد بشير محمد الشنطي",
    "number": "2157",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163046186",
    "name": "محمد بندر غرم الله الحميليس",
    "number": "2158",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160178115",
    "name": "محمد بندر محمد الحارثي",
    "number": "2159",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161280886",
    "name": "محمد تركي محمد الراشدي",
    "number": "2160",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161439458",
    "name": "محمد حسين بن علي الصبياني",
    "number": "2161",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4132475775",
    "name": "محمد حسين سعيد بادكوك",
    "number": "2162",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157352616",
    "name": "محمد حمزه عبدالرزاق حلواني",
    "number": "2163",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161701485",
    "name": "محمد حميد حمدي العبيدي",
    "number": "2164",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2340071451",
    "name": "محمد خالد سعيد سويبق",
    "number": "2165",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159408614",
    "name": "محمد سعد حمود الرشيد",
    "number": "2166",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161603871",
    "name": "محمد سعيد همييل الغامدي",
    "number": "2167",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163771742",
    "name": "محمد سمير سليم الجهني",
    "number": "2168",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163482993",
    "name": "محمد عابد محمد الحربي",
    "number": "2169",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161154420",
    "name": "محمد عبدالعالي طويهر الحربي",
    "number": "2170",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1157991744",
    "name": "محمد عبدالله بن مريف بن سليمان الربعي",
    "number": "2171",
    "room": "22",
    "location": "ثالث سابع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160725881",
    "name": "محمد عبدالله حامد الحربي",
    "number": "2172",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160153720",
    "name": "محمد عبدالله صالح العوفى",
    "number": "2173",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "9683715899-1",
    "name": "محمد علي حسن النهاري",
    "number": "2174",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158846897",
    "name": "محمد علي صالح الزهراني",
    "number": "2175",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2322360385",
    "name": "محمد غسان - تعتاع",
    "number": "2176",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1155910712",
    "name": "محمد مازن يحي باحسن",
    "number": "2177",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2333569123",
    "name": "محمد محجوب دفع الله بله",
    "number": "2178",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2337554915",
    "name": "محمد محمدحازم - البكري",
    "number": "2179",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4057218738",
    "name": "محمد مختار عبدالله عبده",
    "number": "2180",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158534683",
    "name": "محمد مشاري محمد فلمبان",
    "number": "2181",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "6596757",
    "name": "محمد مهند عبدالرحمن المحمد",
    "number": "2182",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1186076723",
    "name": "محمد موسى عبدالله تويتي",
    "number": "2183",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162784548",
    "name": "محمد هاني حميدان الحربي",
    "number": "2184",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2456937032",
    "name": "محمود عبدالرحمن احمد سعد",
    "number": "2185",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161991219",
    "name": "مراد محمد حمدان الجهني",
    "number": "2186",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160652200",
    "name": "مشاري بندر حسن السفياني",
    "number": "2187",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162130304",
    "name": "مشاري عبدالله بن علي الغامدي",
    "number": "2188",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159923901",
    "name": "مشاري علي محمد الغامدي",
    "number": "2189",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164998104",
    "name": "مشاري نافع مبارك السلمي",
    "number": "2190",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "4706815265",
    "name": "مصطفى احمد جعفر عبدالحي",
    "number": "2191",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "60739713831",
    "name": "معاذ جمال دبوان صالح",
    "number": "2192",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "617116",
    "name": "معاذ سلطان عمر عبدالرحمن",
    "number": "2193",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160675086",
    "name": "معاذ فهد دوخى المطيري",
    "number": "2194",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "0160477849",
    "name": "مهنا خالد محمد الكندي",
    "number": "2195",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159033438",
    "name": "مهند سامي محمد المالكي",
    "number": "2196",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161800279",
    "name": "مهند عبدالعزيز يحي الغامدي",
    "number": "2197",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2299103149",
    "name": "موسى محمد محمد بليق",
    "number": "2198",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2314719978",
    "name": "نائل منصور احمد الرمادي",
    "number": "2199",
    "room": "23",
    "location": "ثالث ثامن",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1170136699",
    "name": "ناصر وليد محمد معروف",
    "number": "2200",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163811381",
    "name": "نايف اسعد مساعد الجحدلي",
    "number": "2201",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163516345",
    "name": "نايف عبدالعزيز محمد الغامدي",
    "number": "2202",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166130748",
    "name": "نايف لبيب علي المالكي",
    "number": "2203",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162273567",
    "name": "نواف بدر بهيان القرني",
    "number": "2204",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1185112099",
    "name": "هادي عبدالرحمن بن علي العبيدى",
    "number": "2205",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2341534614",
    "name": "هادي محمد محمد هادي",
    "number": "2206",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159920550",
    "name": "هادي وليد علي صبياني",
    "number": "2207",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1160799324",
    "name": "هاشم حامد ماطر الشيخ",
    "number": "2208",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158466506",
    "name": "هشام علي بن حسن الغامدي",
    "number": "2209",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1171138025",
    "name": "وافي هتان عليان السهلي",
    "number": "2210",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2355776424",
    "name": "وسام محمد علي الملاحي",
    "number": "2211",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2340311204",
    "name": "وسيم نائل ابراهيم بدير",
    "number": "2212",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162944522",
    "name": "ياسر خالد زايد المطيري",
    "number": "2213",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2336324971",
    "name": "ياسر عبدالله حماد عبدالله",
    "number": "2214",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2321921617",
    "name": "يامن احمد ابوبكر بكار",
    "number": "2215",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2447626785",
    "name": "يحي سعيد يحي بن قديم",
    "number": "2216",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162843179",
    "name": "يحي محمد - برناوى",
    "number": "2217",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1158778892",
    "name": "يحيى هادي بن عبدالله الناشري",
    "number": "2218",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161630536",
    "name": "يزن حمود بن معوض الفايدي",
    "number": "2219",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2336795568",
    "name": "يزن عبداللة عبدالقادر بامفلح",
    "number": "2220",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2352985556",
    "name": "يزن فوزي محمد الحافي",
    "number": "2221",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2420960193",
    "name": "يزيد سليمان عمر الكيلاني",
    "number": "2222",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1168586046",
    "name": "يزيد عبدالله رجاء العنزي",
    "number": "2223",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159266814",
    "name": "يزيد محمود عبدالله باصويلح",
    "number": "2224",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2357274725",
    "name": "يوسف أشرف أحمد أحمد",
    "number": "2225",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2323337002",
    "name": "يوسف عنايت الدين رفيق أمان الله",
    "number": "2226",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2385849761",
    "name": "يونس ذكرالله - محمد رسول",
    "number": "2227",
    "room": "24",
    "location": "ثالث تاسع",
    "class": "الثاني المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161360670",
    "name": "البراء احمد محمد قاسم",
    "number": "1014",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1168397170",
    "name": "نايف حسين نايف العقبى",
    "number": "1170",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2363148129",
    "name": "نواف حامد قاسم مثنى",
    "number": "1171",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2361616085",
    "name": "نواف فيصل عبدالله بابصيل",
    "number": "1172",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1163957119",
    "name": "هادي حمد هادي اليامي",
    "number": "1173",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166605525",
    "name": "هتان ذياب عبدالله المطيري",
    "number": "1174",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2365354824",
    "name": "هتان شادى مروان حمدان الشاعر",
    "number": "1175",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164555722",
    "name": "هتان هاني حمدي العوفي",
    "number": "1176",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165134014",
    "name": "وسام أحمد مسفر العلياني",
    "number": "1177",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1167919032",
    "name": "وسام تامر عابد الجهني",
    "number": "1178",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165639384",
    "name": "وسام حسن محمد عبيري",
    "number": "1179",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1159192283",
    "name": "وسام سعد عوض آل سلطان",
    "number": "1180",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "9683639604",
    "name": "وليد وليد سعيد غالب",
    "number": "1181",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2350909186",
    "name": "يحي حسين يحي الغشم",
    "number": "1182",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1168021788",
    "name": "يحي علي يحي مرير",
    "number": "1183",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2318747702",
    "name": "يزن حسام جمعه ابو نبوت",
    "number": "1184",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2350421745",
    "name": "يزن ماهر اسماعيل عدوان",
    "number": "1185",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166559342",
    "name": "يزن هتان عبدالواحد الرابغي",
    "number": "1186",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1168143863",
    "name": "يوسف تامر يحي جمعه",
    "number": "1187",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1162934572",
    "name": "يوسف سلطان غازي مغربي",
    "number": "1188",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1165629914",
    "name": "يوسف عبدالله عبدالحفيظ خان",
    "number": "1189",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1166097616",
    "name": "يوسف علي حسن الشهري",
    "number": "1190",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1161364300",
    "name": "يوسف مديح بن عابد اليهيبي",
    "number": "1191",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "2370723278",
    "name": "يوسف معمر عمر علي ادريس",
    "number": "1192",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  },
  {
    "_id": "1164163519",
    "name": "يوسف نايف علي المالكي",
    "number": "1193",
    "room": "25",
    "location": "اولى اول",
    "class": "الأول المتوسط",
    "school": "عدي بن حاتم المتوسطة"
  }
];

  export default data;